/*! @name @sd/sd-player-plugin @version 0.0.157 @license UNLICENSED */
import videojs from 'video.js';
import window from 'global/window';
import document from 'global/document';

var version = "0.0.157";

const Button$1 = videojs.getComponent('Button') || videojs.getTech('Button');
class SdSeekButton extends Button$1 {
  /**
   * Constructor for Class
   *
   * @param {Player|Object} player Player
   * @param {Object=} options options for button
   * @param {string} options.direction seek forward or backward
   * @param {Int} options.seconds seconds to seek
   */

  constructor(player, options) {
    super(player, options);
    this.controlText(this.options_.direction);
  }
  buildCSSClass() {
    return `vjs-sd-seek-button skip-${this.options_.direction} ` + `skip-${this.options_.seconds} ${super.buildCSSClass()}`;
  }
  handleClick() {
    const now = this.player_.currentTime();
    if (this.options_.direction === 'forward') {
      let duration = this.player_.duration();
      if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
        duration = this.player_.liveTracker.seekableEnd();
      }
      this.player_.currentTime(Math.min(now + this.options_.seconds, duration));
    } else if (this.options_.direction === 'backward') {
      this.player_.currentTime(Math.max(0, now - this.options_.seconds));
    }
  }
}

const subtitlesIcon = '<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.75 0.75H3.25C1.84375 0.75 0.75 1.88281 0.75 3.25V15.75C0.75 17.1562 1.84375 18.25 3.25 18.25H20.75C22.1172 18.25 23.25 17.1562 23.25 15.75V3.25C23.25 1.88281 22.1172 0.75 20.75 0.75ZM21.375 15.75C21.375 16.1016 21.0625 16.375 20.75 16.375H3.25C2.89844 16.375 2.625 16.1016 2.625 15.75V3.25C2.625 2.9375 2.89844 2.625 3.25 2.625H20.75C21.0625 2.625 21.375 2.9375 21.375 3.25V15.75ZM9.96875 8.21094C10.3203 8.5625 10.9453 8.5625 11.2969 8.21094C11.6484 7.82031 11.6484 7.23438 11.2969 6.88281C9.85156 5.39844 7.46875 5.39844 5.98438 6.88281C5.28125 7.58594 4.89062 8.52344 4.89062 9.5C4.89062 10.5156 5.24219 11.4531 5.98438 12.1562C6.72656 12.8984 7.66406 13.25 8.64062 13.25C9.61719 13.25 10.5547 12.8984 11.2969 12.1562C11.6484 11.8047 11.6484 11.2188 11.2969 10.8281C10.9062 10.4766 10.3203 10.4766 9.96875 10.8281C9.22656 11.5703 8.05469 11.5703 7.3125 10.8281C6.96094 10.4766 6.76562 10.0078 6.76562 9.5C6.76562 9.03125 6.96094 8.5625 7.3125 8.21094C8.05469 7.46875 9.22656 7.46875 9.96875 8.21094ZM17.4688 8.21094C17.8203 8.5625 18.4453 8.5625 18.7969 8.21094C19.1484 7.82031 19.1484 7.23438 18.7969 6.88281C17.3516 5.39844 14.9688 5.39844 13.4844 6.88281C12.7812 7.58594 12.3906 8.52344 12.3906 9.5C12.3906 10.5156 12.7422 11.4531 13.4844 12.1562C14.2266 12.8984 15.1641 13.25 16.1406 13.25C17.1172 13.25 18.0547 12.8984 18.7969 12.1562C19.1484 11.8047 19.1484 11.2188 18.7969 10.8281C18.4062 10.4766 17.8203 10.4766 17.4688 10.8281C16.7266 11.5703 15.5547 11.5703 14.8125 10.8281C14.4609 10.4766 14.2656 10.0078 14.2656 9.5C14.2656 9.03125 14.4609 8.5625 14.8125 8.21094C15.5547 7.46875 16.7266 7.46875 17.4688 8.21094Z" fill="currentColor" fill-opacity="0.75"/></svg>';
const speedIcon = '<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 0.75C5.78906 0.75 0.75 5.78906 0.75 12C0.75 14.0703 1.29688 16.0234 2.27344 17.6641C2.46875 18.0547 2.89844 18.2891 3.32812 18.2891H20.6328C21.0625 18.2891 21.4922 18.0547 21.7266 17.6641C22.6641 16.0234 23.25 14.0703 23.25 12C23.25 5.78906 18.2109 0.75 12 0.75ZM12 16.375C11.1016 16.375 10.4375 15.7109 10.4375 14.8125C10.4375 13.9531 11.1016 13.25 12 13.25C12.8594 13.25 13.5625 13.9531 13.5625 14.8125C13.5625 15.7109 12.8594 16.375 12 16.375ZM20.2812 16.375H15.0469C15.2812 15.9062 15.4375 15.3984 15.4375 14.8125C15.4375 13.9141 15.0469 13.0547 14.4609 12.4297L17.4688 7.85938C17.7422 7.39062 17.625 6.84375 17.1953 6.53125C16.7266 6.25781 16.1797 6.375 15.8672 6.80469L12.8203 11.4922C12.5469 11.4531 12.2734 11.375 12 11.375C10.0859 11.375 8.5625 12.9375 8.5625 14.8125C8.5625 15.3984 8.67969 15.9062 8.95312 16.375H3.67969C2.97656 15.0469 2.625 13.5625 2.625 12C2.625 6.84375 6.80469 2.625 12 2.625C17.1562 2.625 21.375 6.84375 21.375 12C21.375 13.5625 20.9844 15.0469 20.2812 16.375Z" fill="currentColor" fill-opacity="0.75"/></svg>';
const optionsMenuIcon = '<svg id="option-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.625 12.5005C17.625 13.5552 18.4453 14.3755 19.5 14.3755C20.5156 14.3755 21.375 13.5552 21.375 12.5005C21.375 11.4849 20.5156 10.6255 19.5 10.6255C18.4453 10.6255 17.625 11.4849 17.625 12.5005ZM6.375 12.5005C6.375 11.4849 5.51562 10.6255 4.5 10.6255C3.44531 10.6255 2.625 11.4849 2.625 12.5005C2.625 13.5552 3.44531 14.3755 4.5 14.3755C5.51562 14.3755 6.375 13.5552 6.375 12.5005ZM13.875 12.5005C13.875 11.4849 13.0156 10.6255 12 10.6255C10.9453 10.6255 10.125 11.4849 10.125 12.5005C10.125 13.5552 10.9453 14.3755 12 14.3755C13.0156 14.3755 13.875 13.5552 13.875 12.5005Z" fill="white"/> </svg>';
const chevronRight = '<svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M2.47656 0.9375L8.0625 6.875C8.21875 7.07031 8.33594 7.30469 8.33594 7.5C8.33594 7.73438 8.21875 7.96875 8.0625 8.16406L2.47656 14.1016C2.125 14.4922 1.53906 14.4922 1.14844 14.1406C0.757812 13.7891 0.757812 13.2031 1.10938 12.8125L6.10938 7.5L1.10938 2.22656C0.757812 1.83594 0.757812 1.25 1.14844 0.898438C1.53906 0.546875 2.125 0.546875 2.47656 0.9375Z" /></svg>';
const checkMark = '<svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M17.4375 0.523438C17.8281 0.914062 17.8281 1.5 17.4375 1.85156L7.125 12.1641C6.77344 12.5547 6.1875 12.5547 5.83594 12.1641L0.523438 6.85156C0.132812 6.5 0.132812 5.91406 0.523438 5.52344C0.875 5.17188 1.46094 5.17188 1.8125 5.52344L6.5 10.2109L16.1484 0.523438C16.5 0.171875 17.0859 0.171875 17.4375 0.523438Z" fill="white"/></svg>';
const qualityIcon = '<svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.75 0.25C15.1172 0.25 16.25 1.38281 16.25 2.75V5.5625H19.0625C19.5703 5.5625 20 5.99219 20 6.5C20 7.04688 19.5703 7.4375 19.0625 7.4375H16.25V10.25C16.25 11.6562 15.1172 12.75 13.75 12.75H12.5C11.0938 12.75 10 11.6562 10 10.25V2.75C10 1.38281 11.0938 0.25 12.5 0.25H13.75ZM13.75 2.125H12.5C12.1484 2.125 11.875 2.4375 11.875 2.75V10.25C11.875 10.6016 12.1484 10.875 12.5 10.875H13.75C14.0625 10.875 14.375 10.6016 14.375 10.25V2.75C14.375 2.4375 14.0625 2.125 13.75 2.125ZM0.9375 5.5625H8.75V7.4375H0.9375C0.390625 7.4375 0 7.04688 0 6.5C0 5.99219 0.390625 5.5625 0.9375 5.5625Z" fill="white" fill-opacity="0.75"/></svg>';

const DomEvents = Object.freeze({
  CLICK: 'click',
  CHANGE: 'change',
  TAP: 'tap',
  MOUSEMOVE: 'mousemove',
  POINTERENTER: 'pointerenter',
  MOUSEENTER: 'mouseenter',
  MOUSELEAVE: 'mouseleave'
});
const PlayerEvents = Object.freeze({
  DISPOSE: 'dispose',
  TIMEUPDATE: 'timeupdate',
  SEEKING: 'seeking',
  SEEKED: 'seeked',
  DURATIONCHANGE: 'durationchange',
  PLAY: 'play'
});
const CustomPlayerEvents = Object.freeze({
  UPDATEOPTIONSMENU: 'updateOptionsMenu',
  LOADCHAPTERS: 'loadChapters',
  LOADFOCUSEXTENSION: 'load-focus-extension',
  REMOVEFOCUSEXTENSION: 'remove-focus-extension'
});
const StoryEvents = Object.freeze({
  CHANGE_SOURCE: 'sd-story-change-source',
  STORY_RESTART: 'sd-story-restart'
});
const QaEvents = Object.freeze({
  ADD_ATTEMPT: 'sd-add-attempt',
  FINISH_SUMMARY: 'sd-qa-finish-summary'
});

/**
 * @file menu-button.js
 */
const Menu$1 = videojs.getComponent('Menu') || videojs.getTech('Menu');
const Component$1 = videojs.getComponent('Component') || videojs.getTech('Component');
const Button = videojs.getComponent('Button') || videojs.getTech('Button');

/**
 * A `MenuButton` class for any popup {@link Menu}.
 *
 * @extends Component
 */
class SdOptionsButton extends Component$1 {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(player, options = {}) {
    super(player, options);
    this.activeItems_ = [];
    this.defaultItems_ = [];
    this.menu_ = null;
    this.activeSubmenuIndex_ = null;
    this.currentPlaybackRate_ = 1;
    this.currentQualityLevel_ = 'auto';
    this.playbackRenditions_ = [];
    this.qualityCodes = new Map([[2160, '4K'], [1080, 'HD'], [720, 'HD'], [480, 'SD'], [360, 'SD'], [240, 'LD'], ['auto', 'AUTO']]);
    const qualityLevels = this.player_.qualityLevels();
    this.autoQualityLevel = 0;
    this.on(qualityLevels, DomEvents.CHANGE, () => {
      this.autoQualityLevel = this.autoQualityLevel === 0 ? qualityLevels.levels_[qualityLevels.selectedIndex_].height : this.autoQualityLevel;
    });
    this.optionsButton_ = new Button(player, options);
    // this.optionsButton_.controlText(this.controlText_); // Tooltip
    this.optionsButton_.el_.setAttribute('aria-haspopup', 'true');

    // Translations because the build in lang does not work
    // this.getLanguage = (key) => this.player_.sdPlugin().getLanguage(key);

    // Add it to the DOM
    this.addChild(this.optionsButton_);
    // * Menu Button Svg */
    this.optionsButton_.el_.innerHTML = optionsMenuIcon;

    // Add buildCSSClass values to the button, not the wrapper
    const buttonClass = Button.prototype.buildCSSClass();
    this.optionsButton_.el_.parentNode.className = this.buildCSSClass();
    this.optionsButton_.className = this.buildCSSClass() + ' ' + buttonClass;
    this.update();
    this.enabled_ = true;
    const handleClick = e => this.handleClick(e);
    this.on(this.optionsButton_, DomEvents.TAP, handleClick);
    this.on(this.optionsButton_, DomEvents.CLICK, handleClick);
    this.on(this.player_, DomEvents.CLICK, e => {
      if (e.target.id === 'option-icon' || e.target.parentNode.id === 'option-icon') {
        return;
      }
      this.unpressButton();
    });
    this.on(this.player_.controlBar.el_, DomEvents.MOUSEMOVE, e => {
      if (!e.target) {
        return;
      }
      // Close the menu if another menu button is hovered
      if (this.enabled_ && e.target.closest('.vjs-hover') || e.target.classList.contains('vjs-hover')) {
        this.unpressButton();
        this.resetMenu();
      }

      // Prevent time display tooltip to go out of the controlbar
      const progressControl = this.player_.controlBar.getChild('ProgressControl');
      const progressBarEl = progressControl.el_;
      const controlWidth = progressBarEl.getBoundingClientRect().width;
      const mouseTimeDisplay = progressControl.getChild('SeekBar').getChild('MouseTimeDisplay');
      if (mouseTimeDisplay) {
        const mouseTimeDisplayEl = mouseTimeDisplay.el_;
        const timeDisplayWidth = mouseTimeDisplayEl.getBoundingClientRect().width;
        const leftAttribute = progressControl.getChild('SeekBar').getChild('MouseTimeDisplay').el_.style.left;
        if (parseFloat(controlWidth) - (Number(timeDisplayWidth) + 15) < parseFloat(leftAttribute)) {
          mouseTimeDisplayEl.firstChild.style.transform = 'translateX(-80%)';
        } else {
          mouseTimeDisplayEl.firstChild.style.transform = 'translateX(0)';
        }
      }
    });

    // Update UI if text track is showing
    const textTracksList = player.textTracks();
    // Event Listener

    /**
     * Update the menu based on the current state of its items.
     */
    // new intersectionObserver((entries) => {}, {
    //   root: null,
    // });

    /**
     * Controlbar
     */

    const subsButton = player.controlBar.getChild('SubsCapsButton');
    subsButton.on(DomEvents.POINTERENTER, function () {
      subsButton.addClass('vjs-hover');
    });
    subsButton.on(DomEvents.MOUSEENTER, function () {
      const menu = this.children_[1];
      // getChild seems to not work index 1 is the OffTextTrackMenuItem component
      const offButton = menu.children_[1];
      offButton.el_.textContent = player.player_.getLanguage('subtitlesOff');
    });
    textTracksList.on(DomEvents.CHANGE, () => {
      const activeTrack = textTracksList.tracks_.find(track => track.mode === 'showing');
      if (!this.options().options.playerSettings.enableControls) {
        return;
      }
      const subsCapsButton = player.controlBar.getChild('SubsCapsButton').el_;
      if (!this.options_.options.playerSettings && !this.options().options.playerSettings.tracks) {
        return;
      }
      const textTracks = this.options().options.playerSettings.tracks.textTracks;
      if (activeTrack) {
        const index = textTracks.findIndex(optionTrack => optionTrack.displayName === activeTrack.label);
        // Item 1 is settings btn Item 2 is subtitles off

        this.activeSubmenuIndex_ = index + 2;
        this.setSubtitlesOffComponent(this.player_.getLanguage('on'));
        subsCapsButton.classList.add('active');
      } else {
        // Item 1 is settings btn Item 2 is subtitles off
        this.activeSubmenuIndex_ = 1;
        this.setSubtitlesOffComponent(this.player_.getLanguage('off'));
        subsCapsButton.classList.add('reverse-active');
        setTimeout(() => {
          subsCapsButton.classList.remove('active');
          subsCapsButton.classList.remove('reverse-active');
        }, 300);
      }
    });
  }

  /**
   * Update the menu based on the current state of its items.
   */
  update() {
    const menu = this.createMenu();
    menu.el_.className = this.buildCSSClass('vjs-options-panel vjs-hidden');
    if (this.menu) {
      this.menu.dispose();
      this.removeChild(this.menu);
    }
    this.menu = menu;
    this.addChild(menu);

    /**
     * Track the state of the menu button
     *
     * @type {Boolean}
     * @private
     */
    this.buttonPressed_ = false;
    this.optionsButton_.el_.setAttribute('aria-expanded', 'false');
    if (this.items && this.items.length <= this.hideThreshold_) {
      this.hide();
      this.menu.contentEl_.removeAttribute('role');
    } else {
      this.show();
      this.menu.contentEl_.setAttribute('role', 'menu');
    }
  }

  /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */
  createMenu() {
    this.menu_ = new Menu$1(this.player_, {
      optionButton: this
    });
    /**
     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
     * it here because every time we run `createMenu` we need to reset the value.
     *
     * @protected
     * @type {Number}
     */

    this.hideThreshold_ = 0;
    /*
    Autoplay
     */
    // const autoplayEl = this.createItem('vjs-sd-autoplay vjs-last-el-auto vjs-option', 'Autoplay', 1)
    // const autoplayComponent = new Component(this.player_, {el: autoplayEl});
    // autoplayEl.insertAdjacentHTML('afterbegin', autoplayIcon);
    // autoplayEl.insertAdjacentHTML('beforeend', toggleActiveIcon);

    /*
    Subtitles
     */
    const subtitleEl = this.createItem('vjs-sd-subtitle vjs-last-el-auto vjs-option', this.player_.getLanguage('subtitles'), 2);
    const subtitleComponent = new Component$1(this.player_, {
      el: subtitleEl
    });
    this.hideTracks();
    subtitleEl.insertAdjacentHTML('afterbegin', subtitlesIcon);
    subtitleEl.insertAdjacentHTML('beforeend', `<span style="margin-right:2px; margin-left: auto ">${this.player_.getLanguage('off')}</span>`);
    subtitleEl.insertAdjacentHTML('beforeend', chevronRight);
    subtitleEl.addEventListener('click', () => {
      this.handleSubtitleItems();
    });

    /*
    More Options
    */
    // const moreOptionsEl = this.createItem('vjs-sd-more-options vjs-option','More Options', 2 )
    // const autoPlayComponent = new Component(this.player_, {el: moreOptionsEl});
    // moreOptionsEl.insertAdjacentHTML('afterbegin', moreOptionsIcon);

    /*
    speedEl
    */
    const speedEl = this.createItem('vjs-sd-speed vjs-last-el-auto vjs-option', this.player_.getLanguage('speed'), 3);
    const speedComponent = new Component$1(this.player_, {
      el: speedEl
    });
    speedEl.insertAdjacentHTML('afterbegin', speedIcon);
    speedEl.insertAdjacentHTML('beforeend', `<span style="margin-right:auto">(${this.currentPlaybackRate_}x)</span>`);
    speedEl.insertAdjacentHTML('beforeend', chevronRight);
    speedEl.addEventListener('click', () => {
      this.handleSpeedItems();
    });

    /**
     * Renditions (Quality)
     */
    const renditionEl = this.createItem('vjs-sd-quality vjs-option', this.player_.getLanguage('quality'), 4);
    renditionEl.insertAdjacentHTML('afterbegin', qualityIcon);
    renditionEl.insertAdjacentHTML('beforeend', `<span style="margin-right:2px; margin-left: auto ">${this.currentQualityLevel_}</span>`);
    renditionEl.insertAdjacentHTML('beforeend', chevronRight);
    // Make same size as other icons
    renditionEl.firstChild.style.width = '24px';
    const renditionComponent = new Component$1(this.player_, {
      el: renditionEl
    });
    renditionEl.addEventListener('click', () => {
      this.handleRenditionItems();
    });

    // Creating menu items
    // const items = [autoplayComponent, subtitleComponent, autoPlayComponent, renditionComponent, speedComponent];
    if (this.options_.options.playerSettings && this.options_.options.playerSettings.tracks && this.options_.options.playerSettings.tracks.textTracks.length) {
      this.activeItems_ = [subtitleComponent, speedComponent, renditionComponent];
      this.defaultItems_ = [subtitleComponent, speedComponent, renditionComponent];
    } else {
      this.activeItems_ = [speedComponent, renditionComponent];
      this.defaultItems_ = [speedComponent, renditionComponent];
    }

    // Add menu items to the menu
    for (let i = 0; i < this.activeItems_.length; i++) {
      this.menu_.addItem(this.activeItems_[i]);
    }
    return this.menu_;
  }

  /**
   * Shared Methods for option menu items
   */
  resetMenu() {
    for (let i = 0; i < this.activeItems_.length; i++) {
      this.menu_.removeChild(this.activeItems_[i]);
    }
    this.activeItems_ = [...this.defaultItems_];
    this.activeItems_.forEach(component => {
      this.menu_.addItem(component);
    });
  }
  removeItems() {
    for (let i = 0; i < this.activeItems_.length; i++) {
      this.menu_.removeChild(this.activeItems_[i]);
    }
    this.activeItems_ = [];
  }
  removeCheckmark() {
    this.activeItems_.forEach(item => {
      const checkmark = item.el_.querySelector('svg');
      if (checkmark) {
        checkmark.remove();
      }
    });
  }

  /**
   * Subtitle methods
   */
  hideSubtitles(el) {
    const tracks = this.player_.textTracks();
    this.removeCheckmark();
    el.insertAdjacentHTML('beforeend', checkMark);
    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i];

      // Disable all metadata which are getting added in production
      if (track.kind === 'metadata') {
        track.mode = 'disabled';
      }
      track.mode = 'hidden';
    }
    this.activeSubmenuIndex_ = 0;
    this.resetMenu();
    this.unpressButton();
  }
  handleSubtitleItems() {
    if (!this.options_.options.playerSettings.tracks) {
      return;
    }
    const textTracks = this.options_.options.playerSettings.tracks.textTracks;
    this.removeItems();
    const tracksSettingsElement = this.createItem('vjs-sd-subtitle vjs-option', this.player_.getLanguage('settings'), 0);
    const tracksSettingsComponent = new Component$1(this.player_, {
      el: tracksSettingsElement
    });

    // Add event because default logic does not run on done
    tracksSettingsElement.addEventListener('click', () => {
      this.player_.textTrackSettings.show();
      const doneButton = this.player_.textTrackSettings.el().querySelector('.vjs-done-button');
      // Close Menu

      this.unpressButton();
      // Add event listeners to the reset and done buttons
      doneButton.addEventListener('click', () => {
        this.player_.textTrackSettings.hide();
      });
    });
    this.activeItems_.push(tracksSettingsComponent);
    this.menu_.addItem(tracksSettingsComponent);
    const offElement = this.createItem('vjs-sd-subtitle vjs-option', this.player_.getLanguage('off'), 1);
    const offComponent = new Component$1(this.player_, {
      el: offElement
    });
    offElement.addEventListener('click', () => {
      this.hideSubtitles(offElement);
    });
    this.activeItems_.push(offComponent);
    this.menu_.addItem(offComponent);
    textTracks.forEach((item, index) => {
      const trackEl = this.createItem(`vjs-sd-track ${'subtitle-' + item.displayName} vjs-option`, item.displayName, ++index + 1);
      const tracksComponent = new Component$1(this.player_, {
        el: trackEl
      });
      this.activeItems_.push(tracksComponent);
      this.menu_.addItem(tracksComponent);
      trackEl.addEventListener('click', () => {
        this.setActiveSubTitle(item, trackEl);
      });
    });
    if (this.activeSubmenuIndex_ === null) {
      offElement.insertAdjacentHTML('beforeend', checkMark);
    } else {
      this.activeItems_[this.activeSubmenuIndex_].el_.insertAdjacentHTML('beforeend', checkMark);
    }
  }
  setSubtitlesOffComponent(text) {
    this.defaultItems_.forEach(item => {
      if (item.el_.classList.contains('vjs-sd-subtitle')) {
        item.el_.textContent = 'Sub Titles';
        item.el_.insertAdjacentHTML('afterbegin', subtitlesIcon);
        item.el_.insertAdjacentHTML('beforeend', `<span style="margin-right:2px; margin-left: auto ">${text}</span>`);
        item.el_.insertAdjacentHTML('beforeend', chevronRight);
      }
    });
  }
  setActiveSubTitle(track, trackEl) {
    this.removeCheckmark();
    this.menu.children_.forEach(child => {
      child.el_.removeAttribute('aria-checked');
    });
    trackEl.setAttribute('aria-checked', 'true');
    const tracks = this.player_.textTracks();
    const index = tracks.tracks_.findIndex(textTrack => textTrack.label === track.displayName);
    // hide all tracks to prevent bug on switching subtitles

    this.hideTracks();
    this.activeSubmenuIndex_ = this.activeItems_.findIndex(item => item.el_.classList.contains(`subtitle-${tracks.tracks_[index].label}`));
    trackEl.insertAdjacentHTML('beforeend', checkMark);
    tracks.tracks_[index].mode = 'showing';
    this.unpressButton();
    this.resetMenu();
  }
  hideTracks() {
    const tracks = this.player_.textTracks();
    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i];
      track.mode = 'disabled';
    }
  }

  /**
   * Renditions methods
   */

  handleRenditionItems() {
    this.playbackRenditions_ = this.player_.tech({
      IWillNotUseThisInPlugins: true
    }).vhs.representations();
    const sortedQualityLevels = this.playbackRenditions_.sort((a, b) => +b.height - +a.height);
    this.removeItems();
    const autoEl = this.createItem('vjs-sd-quality vjs-option', this.player_.getLanguage('auto') + ' (' + this.autoQualityLevel + 'p)', 0);
    autoEl.setAttribute('value', 'auto');
    const autoComponent = new Component$1(this.player_, {
      el: autoEl
    });
    this.activeItems_.push(autoComponent);
    this.menu_.addItem(autoComponent);
    sortedQualityLevels.unshift();
    autoEl.addEventListener('click', ev => {
      this.handleRendition(ev);
    });
    if (typeof this.currentQualityLevel_ === 'string') {
      autoEl.insertAdjacentHTML('beforeend', checkMark);
    }
    sortedQualityLevels.forEach((level, index) => {
      const textContent = `${level.height}p (${this.getQualityCode(level.height)})`;
      const qualityEl = this.createItem('vjs-sd-quality vjs-option', textContent, ++index);
      qualityEl.setAttribute('value', level.height);
      const qualityComponent = new Component$1(this.player_, {
        el: qualityEl
      });
      if (+this.currentQualityLevel_ === +level.height) {
        qualityEl.insertAdjacentHTML('beforeend', checkMark);
      }
      qualityEl.addEventListener('click', ev => {
        this.handleRendition(ev);
      });
      this.activeItems_.push(qualityComponent);
      this.menu_.addItem(qualityComponent);
    });
  }
  handleRendition(ev) {
    const renditionHeight = ev.target.value;
    const selectedRendition = this.playbackRenditions_.find(level => level.height === renditionHeight);
    this.setQualityLevel(selectedRendition, ev.target);
    this.defaultItems_.forEach(item => {
      if (item.el_.classList.contains('vjs-sd-quality')) {
        item.el_.textContent = this.player_.getLanguage('quality');
        item.el_.insertAdjacentHTML('afterbegin', qualityIcon);
        item.el_.insertAdjacentHTML('beforeend', `<span style="margin-right:2px; margin-left: auto ">${this.currentQualityLevel_}${typeof this.currentQualityLevel_ === 'string' ? '' : 'p'}</span>`);
        item.el_.insertAdjacentHTML('beforeend', chevronRight);
      }
    });
    this.resetMenu();
    this.unpressButton();
    this.player_.play();
  }
  getQualityCode(height) {
    let closestHeight = null;

    // Iterate through the map to find the closest matching height
    for (const [key] of this.qualityCodes) {
      if (key === 'auto') {
        continue;
      }
      if (closestHeight === null || Math.abs(key - height) < Math.abs(closestHeight - height)) {
        closestHeight = key;
      }
    }

    // Return the quality code for the closest matching height
    return this.qualityCodes.get(closestHeight) || '';
  }
  setQualityLevel(rendition, qualityElement) {
    this.removeCheckmark();
    if (qualityElement.getAttribute('value') === 'auto') {
      this.currentQualityLevel_ = 'auto (' + this.autoQualityLevel + 'p)';
    } else {
      this.currentQualityLevel_ = rendition.height;
    }

    // If rendition is undefined it means auto got selected
    if (rendition) {
      for (let i = 0; i < this.playbackRenditions_.length; i++) {
        const quality = this.playbackRenditions_[i];
        quality.enabled(quality.height === rendition.height);
      }
    } else {
      for (let i = 0; i < this.playbackRenditions_.length; i++) {
        const quality = this.playbackRenditions_[i];
        quality.enabled(quality.height === this.autoQualityLevel);
      }
    }
    // Add checkmark
    qualityElement.insertAdjacentHTML('beforeend', checkMark);
  }

  /**
   * Speed methods
   */
  handleSpeedItems() {
    const playbackRates = this.options_.options.playbackRates;
    this.removeItems();
    playbackRates.forEach((rate, index) => {
      const speedEl = this.createItem('vjs-sd-speed vjs-option', rate + 'x', index);
      speedEl.setAttribute('value', rate);
      const speedComponent = new Component$1(this.player_, {
        el: speedEl
      });
      speedEl.addEventListener('click', () => {
        this.setPlayerSpeed(rate);
        this.defaultItems_.forEach(item => {
          if (item.el_.classList.contains('vjs-sd-speed')) {
            item.el_.textContent = this.player_.getLanguage('speed');
            item.el_.insertAdjacentHTML('afterbegin', speedIcon);
            item.el_.insertAdjacentHTML('beforeend', `<span style="margin-right: auto">(${this.currentPlaybackRate_ + 'x'})</span>`);
            item.el_.insertAdjacentHTML('beforeend', chevronRight);
          }
        });
        this.resetMenu();
        this.unpressButton();
      });
      this.activeItems_.push(speedComponent);
      this.menu_.addItem(speedComponent);
    });
    const currentRate = this.player().playbackRate();
    const defaultSpeed = this.activeItems_.find(component => +component.el_.getAttribute('value') === currentRate);
    if (defaultSpeed) {
      this.removeCheckmark();
      defaultSpeed.el_.insertAdjacentHTML('beforeend', checkMark);
    }
  }
  setPlayerSpeed(rate) {
    this.player().playbackRate(rate);
    this.currentPlaybackRate_ = rate;
  }

  /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */

  buildCSSClass(customClass = false) {
    if (customClass) {
      return `${customClass} ${super.buildCSSClass()}`;
    }
    return `vjs-options-button ${super.buildCSSClass()}`;
  }

  /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return super.createEl('div', {
      className: this.buildWrapperCSSClass()
    }, {});
  }

  /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */
  buildWrapperCSSClass() {
    // // TODO: Fix the CSS so that this isn't necessary
    // const buttonClass = Button.prototype.buildCSSClass();
    // return `vjs-menu-button ${optionsButton} ${buttonClass} ${super.buildCSSClass()}`;
    return `vjs-menu-button ${super.buildCSSClass()}`;
  }

  /**
   * Set the focus to the actual button, not to this element
   */
  focus() {
    this.optionsButton_.focus();
  }

  /**
   * Remove the focus from the actual button, not this element
   */
  blur() {
    this.optionsButton_.blur();
  }
  createItem(classNames, textContent, tabIndex, tag = 'li') {
    return videojs.dom.createEl(tag, {
      className: classNames,
      textContent,
      tabIndex
    });
  }

  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick() {
    if (this.buttonPressed_) {
      this.unpressButton();
    } else {
      this.pressButton();
    }
  }

  /**
   * Put the current `MenuButton` into a pressed state.
   */
  pressButton() {
    if (this.enabled_) {
      this.buttonPressed_ = true;
      this.menu.show();
      this.menu.lockShowing();
      this.optionsButton_.el_.setAttribute('aria-expanded', 'true');
      setTimeout(() => {
        this.menu.addClass('slide-up');
      }, 1);
      // set the focus into the submenu, except on iOS where it is resulting in
      // undesired scrolling behavior when the player is in an iframe
      if (videojs.IS_IOS && videojs.dom.isInFrame()) {
        // Return early so that the menu isn't focused
        return;
      }
      this.menu.focus();
    }
  }

  /**
   * Take the current `MenuButton` out of a pressed state.
   */
  unpressButton() {
    if (this.enabled_) {
      this.buttonPressed_ = false;
      this.menu.removeClass('slide-up');
      setTimeout(() => {
        this.menu.unlockShowing();
        this.optionsButton_.el_.setAttribute('aria-expanded', 'false');
        this.menu.hide();
      }, 250);
      this.resetMenu();
    }
  }

  /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */
  // disable() {
  //   this.unpressButton();
  //   this.enabled_ = false;
  //   this.addClass('vjs-disabled');
  //   this.optionsButton_.disable();
  // }
}

const MenuButton = videojs.getComponent('MenuButton');
const Menu = videojs.getComponent('Menu');
class SdQualityMenu extends MenuButton {
  constructor(player) {
    super(player, {
      title: 'möpmöp :D',
      name: 'QualitySelector'
    });
    super.addClass('vjs-sd-qualityselector');
  }
  buildCSSClass() {
    return `vjs-sd-qualityselector-button ${super.buildCSSClass()}`;
  }
  setTitle(text) {
    this.menuButton_.$('.vjs-icon-placeholder').innerHTML = text;
  }
  createItems() {
    return [];
  }
  createMenu() {
    const menu = new Menu(this.player_, {
      MenuButton: this
    });
    this.hideThreshold_ = 0;
    this.items = this.createItems();
    if (this.items) {
      for (let i = 0; i < this.items.length; i++) {
        menu.addItem(this.items[i]);
      }
    }
    return menu;
  }
}

const dom$5 = videojs.dom;
class SdThumbnails {
  /**
   * Constructor for Class
   *
   * @param {Player|Object} player Player
   * @param {Object} plugin holds plugin
   * @param {Object} options
   */

  constructor(player, plugin, options) {
    this.player = player;
    this.plugin = plugin;
    this.options = options;

    // hiRes Sprites
    this.hiResUrls = [];
    this.hiResSprites = {};
    this.higResSegments = 1;

    // standard Sprites
    this.url = '/' + this.options.directory + '/sprite-0001.jpg';
    this.urls = [];
    this.sprites = {};
    this.segments = 1;

    // standard Sprite Dimensions
    this.width = this.options.width;
    this.height = this.options.height;

    // preloading or not
    this.isPreloading = false;
    this.controls = player.controlBar;
    this.progressControl = this.controls && this.controls.progressControl;
    this.seekBar = this.progressControl && this.progressControl.seekBar;
    this.mouseTimeTooltip = this.seekBar && this.seekBar.mouseTimeDisplay && this.seekBar.mouseTimeDisplay.timeTooltip;

    // Wrap time in span that it can be places outsite of thumbnail via css
    this.mouseTimeTooltip.update = function (seekBarRect, seekBarPoint, time) {
      this.write('');
      const span = document.createElement('span');
      span.innerHTML = time;
      this.el().appendChild(span);
      this.el().style.left = '-80px';
    };
  }

  /**
   * Init Thumnail
   * generates urls and triggers preload
   * activated on duration change, because duration is needed for generating urls
   */

  init() {
    const that = this;
    this.player.on(PlayerEvents.DURATIONCHANGE, () => {
      const duration = this.player.duration();
      this.segments = Math.ceil(duration / (this.options.interval * 100));
      this.highResSegments = this.segments * 4;

      // generate low res URLS
      for (let i = 1; i <= this.segments; i++) {
        this.urls.push(`/${this.options.directory}/sprite-000${i}.jpg`);
      }

      // generate low res URLS
      for (let i = 1; i <= this.higResSegments; i++) {
        this.hiResUrls.push(`/${this.options.directory}/large-sprite-000${i}.jpg`);
      }
      if (that.isPreloading) {
        that.isPreloading = false;
      } else {
        that.spriteready(false);
      }
    });
  }

  /**
   * Sets Styles on mouseTooltip
   *
   * @param {Object} obj holds styles for Tooltip
   */

  tooltipStyle(obj) {
    const style = this.mouseTimeTooltip.el().style;
    Object.keys(obj).forEach(key => {
      const val = obj[key];
      if (val !== '') {
        style.setProperty(key, val);
      } else {
        style.removeProperty(key);
      }
    });
  }

  /**
   * Resets styles of Tooltip
   */

  resetMouseTooltip() {
    this.tooltipStyle({
      'width': '',
      'height': '',
      'background-image': '',
      'background-repeat': '',
      'background-position': '',
      'background-size': '',
      'top': '',
      'color': '',
      'text-shadow': '',
      'border': '',
      'margin': ''
    });
  }

  /**
   * Sets Plugin ready
   * @param {bool} bool ready state
   */

  setReady(bool) {
    this.plugin.setState({
      ready: bool
    });
  }

  /**
   * Generate ThumnailTooltip either hiRes or preloaded standard
   *
   * @param {Number} pos actual position on timeline divided by interval
   * @param {int} index index of Thumbnail
   * @param {string} url thumnailUrl [large-]sprite-{index}.jpg
   * @param {boolean} isHires is hiRes Thumnail
   */

  generateThumbnailTooltip(pos, index, url, isHiRes = false) {
    // standard vars
    const imgWidth = this.options.spriteWidth;
    const imgHeight = this.options.spriteHeight;
    const responsiveBreakpoint = this.options.responsive;
    const playerWidth = this.player.currentWidth();

    // get acutal thumbnail position in sprite
    // hiRes sprite holds 25 pictures
    // loRes sprite holds 100 pictures
    pos = pos - index * (isHiRes ? 25 : 100);

    // calc ScaleFactor of Thumbs
    const scaleFactor = responsiveBreakpoint && playerWidth < responsiveBreakpoint ? playerWidth / responsiveBreakpoint : 1;

    // calc Columns of Sprites
    const columns = imgWidth / (this.width * (isHiRes ? 2 : 1));

    // calc scaled Size of Thumb
    const scaledWidth = this.width * scaleFactor;
    const scaledHeight = this.height * scaleFactor;

    // calc position on sprite
    const cLeft = Math.floor(pos % columns) * -scaledWidth;
    const cTop = Math.floor(pos / columns) * -scaledHeight;

    // set Size of Sprite
    const bgSize = `${imgWidth / (isHiRes ? 2 : 1) * scaleFactor}px ${imgHeight / (isHiRes ? 2 : 1) * scaleFactor}px`;

    // calc Top position to show thumbnail
    const seekBarEl = this.seekBar.el();
    const controlsTop = dom$5.findPosition(this.controls.el()).top;
    const seekBarTop = dom$5.findPosition(seekBarEl).top;
    const topOffset = -scaledHeight - Math.max(0, seekBarTop - controlsTop) - 20;

    // set Styles of TooltibThumbnail
    this.tooltipStyle({
      'width': `${scaledWidth}px`,
      'height': `${scaledHeight}px`,
      'background-image': `url(${url})`,
      'background-repeat': 'no-repeat',
      'background-position': `${cLeft}px ${cTop}px`,
      'background-size': bgSize,
      'top': `${topOffset}px`,
      'color': '#fff',
      'margin': '0 1px'
    });
  }

  /**
   * Checks if hiResSprite on position is already loaded or not
   * If not it is lazy loaded and standard preloaded sprite is shown
   * If it has been loaded show ist
   *
   * @param {Event} event mouseevent to calc position
   */
  mutateMousetooltip(event) {
    // standard vars
    const seekBarEl = this.seekBar.el();

    // get position to calculate index of file -> [large-]sprite-{index}.jpg
    let pos = dom$5.getPointerPosition(seekBarEl, event).x * this.player.duration();
    pos = pos / this.options.interval;

    // get hiResIndex first to reload hires Thumb on demand
    const indexOfHiResUrl = Math.floor(pos * 4 / 100);
    const hiResUrl = `/${this.options.directory}/large-sprite-00${indexOfHiResUrl + 1 < 10 ? '0' + (indexOfHiResUrl + 1) : indexOfHiResUrl + 1}.jpg`;

    // select hiResSprite
    const hiResSprite = this.hiResSprites[hiResUrl];

    // check if there is a hiResSprite
    // if not loaded load it and show standard preloaded sprite
    if (hiResSprite === undefined) {
      this.hiResSprites[hiResUrl] = new window.Image();
      this.hiResSprites[hiResUrl].src = hiResUrl;
    } else if (hiResSprite.complete) {
      this.generateThumbnailTooltip(pos, indexOfHiResUrl, hiResUrl, true);
      return;
    }

    // if there is no hiResSprite load sprite instead
    const indexOfUrl = Math.floor(pos / 100);
    const url = `/${this.options.directory}/sprite-00${indexOfUrl + 1 < 10 ? '0' + (indexOfUrl + 1) : indexOfUrl + 1}.jpg`;
    const sprite = this.sprites[url];
    if (sprite.complete) {
      this.generateThumbnailTooltip(pos, indexOfUrl, url, false);
    } else {
      this.resetMouseTooltip();
    }
  }

  /**
   * Starts loading sprites and sets listener to mutate Tooltips
   *
   * @param {bool} preload preload sprite or not
   */
  spriteready(preload) {
    const events = ['mousemove', 'touchmove'];
    const downlink = this.options.downlink;
    const navigator = window.navigator;
    const connection = navigator.connection || navigator.mozConnecteion || navigator.webkitConnection;
    const dl = !connection || connection.downlink > downlink;
    const ready = this.mouseTimeTooltip && (this.width && this.height || preload);
    const cached = this.sprites[this.url];
    if (this.mouseTimeTooltip) {
      this.resetMouseTooltip();
    }
    if (ready && (this.url && dl || cached)) {
      if (!cached) {
        const that = this;
        this.urls.forEach(url => {
          that.sprites[url] = new window.Image();
          that.sprites[url].src = url;
        });
        if (preload) {
          this.isPreloading = true;
        }
      }
      this.progressControl.on(events, e => {
        this.mutateMousetooltip(e);
      });
      this.setReady(true);
    } else if (!preload) {
      this.progressControl.off(events, e => {
        this.mutateMousetooltip(e);
      });
      this.setReady();
    }
  }
}

const Component = videojs.getComponent('Component') || videojs.getTech('Component');
class SdRecommendList extends Component {
  constructor(player, options) {
    super(player, options);
  }
  createEl() {
    return videojs.dom.createEl('ul', {
      className: 'vjs-recommendation-list'
    });
  }
  updateRecommenderItem() {}
}

const dom$4 = videojs.dom || videojs;
class SdQuestionSet {
  constructor(player, options, questionSet, attempt, quizSettings, interaction) {
    this.player = player;
    this.player.controls(false);
    this.options = options;
    this.apiUrl = options.apiUrl;
    this.feedbackActive = false;
    /*
      after leaving qa disable it
     */
    this.currentInteraction = interaction;
    this.questionSet = questionSet;
    if (questionSet) {
      this.questions = questionSet.questions;
    } else {
      this.questions = [];
    }
    this.currentIndex = 0;
    this.currentQuestion = this.questions[this.currentIndex];
    this.attempt = attempt;
    this.quizSettings = quizSettings;
    this.answerHistory = [];
    /* title, description,
         options: { title: string, sceneId: string, type: redirect or continue} */
    if (questionSet) {
      this.show();
    }
  }
  createEl() {
    const findEl = document.getElementById('question-set');
    if (findEl) {
      findEl.remove();
    }
    if (this.quizSettings) ;
    const el = dom$4.createEl('div', {
      className: 'vjs-question-set',
      id: 'question-set'
    });
    const stylesheet = dom$4.createEl('style');
    stylesheet.type = 'text/css';
    // const getString
    stylesheet.setAttribute('id', `${this.questionSet.id}-style`);
    stylesheet.appendChild(document.createTextNode(`
        .vjs-question-set {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: 1rem;
            border-radius: 6px;
            border: 1px solid rgba(0, 0, 0, 0.10);
            background: rgba(255,255,255,0.95);
            display: flex;
            padding: 8px 16px;
            flex-direction: column;
            gap: 8px;
            justify-content: start;
            align-items: start;
            z-index: 999;
          }
          .vjs-question-set-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            min-height: 50px;
            padding: 0px 8px;
            gap: 8px;
          }
          .vjs-question-set-header > h3 {
            color: #121D29;
            text-overflow: ellipsis;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            margin: 0;
            flex: 1 0 0;
            overflow: hidden;
          }
          .vjs-question-set-row {
            display: flex;
            padding: 16px;
            flex-direction: column;
            align-items: center;
            gap: 8px;
            align-self: stretch;
            border-radius: 6px;
            background: var(--08-Black-Black-5, rgba(0, 0, 0, 0.05));
          }
           .vjs-question-set-row > .vjs-question-set-label, .vjs-question-set-question {
            margin: 0;
            align-self: stretch;
            color: var(--07-Neutral-Neutral-800, #121D29);
            /* 07 Subtitle 1 */
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px; /* 150% */
           }
           .vjs-question-set-row > .vjs-question-set-label {
            text-transform: uppercase;
           }
           .vjs-question-set-answer-row {
              display: flex;
              padding: 16px;
              flex-direction: column;
              flex-grow: 1;
              align-items: flex-center;
              align-self: stretch;
              border-radius: 6px;
              border: 1px solid var(--08-Black-Black-10, rgba(0, 0, 0, 0.10));
              background: var(--08-Black-Black-5, rgba(0, 0, 0, 0.05));
              box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.10) inset;
              overflow: hidden;
           }
           .vjs-question-set-answer-row > .vjs-question-set-answer-options-container {
              overflow-y: auto;
              flex-grow: 1;
              display: flex;
              flex-direction: column;
              width: 100%;
              position: relative;
           }
           .vjs-question-set-answer-row > .vjs-question-set-answer-label-container > .vjs-question-set-answer-label {
              color:  #121D29;
              margin-bottom: 8px;
              /* 12 Overline */
              font-size: 14px ;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
              letter-spacing: 1px;
              text-transform: uppercase;
               align-self: stretch
           }

           .vjs-question-set-answer-row > .vjs-question-set-answer-label-container {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
           }

           .vjs-question-set-free-text-container {
              display: flex;
              align-items: center;
              position: relative;
              max-width: 100%;
              align-self: stretch;
              flex-grow: 1;
           }
           .vjs-question-set-free-text-container > .vjs-question-set-free-text-input {
              font-size: 16px;
              padding: 12px 16px;
              width: 100%;
              height: 100%;
              outline: none;
              background: #FFFFFF;
              color: #000000;
              border: 1px solid #C4D1EB;
              border-radius: 5px;
              transition: .3s ease;
           }
           .vjs-question-set-free-text-container > .vjs-question-set-free-text-input:focus {
              background: #F2F2F2;
              border: 1px solid #5A7EC7;
              border-radius: 6px;
           }
           .vjs-question-set-free-text-container > .vjs-question-set-free-text-input::placeholder {
              color: #DDDDDD;
           }



          .vjs-question-set-input-wrapper input {
            position: absolute;
            z-index: -1;
            opacity: 0;
          }

          .vjs-question-set-input-wrapper span {
            font-size: 16px;
          }

          .vjs-question-set-input-wrapper {
            display: flex;
            width: 100%;
            flex-wrap: wrap;
            min-height: fit-content;
            position: relative;
            padding: 12px 16px;
            overflow: visible;
            align-items: start;
            padding-left: 46px;
            cursor: pointer;
            background: white;
            border-top: 1px solid rgba(0, 0, 0, 0.10);
            box-sizing: border-box;
            font-size: 16px;
            color: black;
          }

          .vjs-question-set-input-wrapper input[type="checkbox"] ~ .vjs-question-set-input-wrapper-custom {
            position: absolute;
            top: 50%;
            left: 16px;
            height: 20px;
            width: 20px;
           background: #FFFFFF;
            transition: background 250ms;
            border: 1px solid #0053F9;
            border-radius: 4px;
            transform: translate(0, -50%);
          }

          .vjs-question-set-input-wrapper input[type="radio"] ~ .vjs-question-set-input-wrapper-custom {
            position: absolute;
            top: 50%;
            left: 16px;
            height: 20px;
            width: 20px;
           background: #FFFFFF;
            transition: background 250ms;
            border: 1px solid #0053F9;
            border-radius: 20px;
            transform: translate(0, -50%);
          }

          .vjs-question-set-input-wrapper input[type="checkbox"] ~ .vjs-question-set-input-wrapper-custom::after {
            content: "";
            position: absolute;
            display: none;
            left: 4px;
            top: 4px;
            width: 12px;
            height: 12px;
            transition: background 250ms;
            background-color: #FFFFFF;
            clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
          }

          .vjs-question-set-input-wrapper input[type="radio"] ~ .vjs-question-set-input-wrapper-custom::after {
            content: "";
            position: absolute;
            display: none;
            left: 3px;
            top: 4px;
            width: 10px;
            height: 10px;
            border-radius: 20px;
            background: #FFFFFF;
            transition: background 250ms;
          }

          .vjs-question-set-input-wrapper input:checked ~ .vjs-question-set-input-wrapper-custom::after {
            display: block;
          }

          .vjs-question-set-input-wrapper:hover input[type="checkbox"]:not([disabled]) ~ .vjs-question-set-input-wrapper-custom,
          .vjs-question-set-input-wrapper input[type="checkbox"]:focus ~ .vjs-question-set-input-wrapper-custom {
            border-color: #1264D4;
            background: #FFF;
          }

          .vjs-question-set-input-wrapper:hover input[type="radio"]:not([disabled]) ~ .vjs-question-set-input-wrapper-custom,
          .vjs-question-set-input-wrapper input[type="radio"]:focus ~ .vjs-question-set-input-wrapper-custom {
            border-color: #1264D4;
            background: #FFF;
          }

          .vjs-question-set-input-wrapper input[type="checkbox"]:checked ~ .vjs-question-set-input-wrapper-custom {
            border-color: #1264D4;
            background: #FFF;
          }

          .vjs-question-set-input-wrapper input[type="radio"]:checked ~ .vjs-question-set-input-wrapper-custom {
             border-color: #1264D4;
             background: #FFF;
          }

          .vjs-question-set-input-wrapper input[type="checkbox"]:disabled ~ .vjs-question-set-input-wrapper-custom,
          .vjs-question-set-input-wrapper input[type="radio"]:disabled ~ .vjs-question-set-input-wrapper-custom {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .vjs-question-set-input-wrapper input[type="checkbox"]:disabled ~ .vjs-question-set-input-label,
          .vjs-question-set-input-wrapper input[type="radio"]:disabled ~ .vjs-question-set-input-label {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .vjs-question-set-input-wrapper input[type="checkbox"]:disabled ~ .vjs-question-set-input-wrapper-custom::after {
            background: #FFFFFF;
          }

          .vjs-question-set-input-wrapper input[type="radio"]:disabled ~ .vjs-question-set-input-wrapper-custom::after {
            background: #FFFFFF;
          }

          .vjs-question-set-input-wrapper:hover input[type="checkbox"]:not([disabled]):checked ~ .vjs-question-set-input-wrapper-custom,
          .vjs-question-set-input-wrapper input[type="checkbox"]:checked ~ .vjs-question-set-input-wrapper-custom {
            background: #1264D4;
            border-color: #1264D4;
          }

          .vjs-question-set-input-wrapper:hover input[type="radio"]:not([disabled]):checked ~ .vjs-question-set-input-wrapper-custom,
          .vjs-question-set-input-wrapper input[type="radio"]:checked ~ .vjs-question-set-input-wrapper-custom {
            background: #1264D4;
            border-color: #1264D4;
          }
          .vjs-question-set-footer {
            align-self: stretch;
            gap: 8px;
            display: flex;
            flex-direction: column;
          }
          .vjs-question-set-footer > .vjs-question-set-footer-btn-row {
            display: flex;
            padding: 0px 8px;
            align-items: center;
            gap: 8px;
          }
          .vjs-question-set-footer-span {
            color: var(--07-Neutral-Neutral-800, #121D29);

            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
          }
          .vjs-question-set-footer-btn-primary, .vjs-question-set-footer-btn-secondary {
            display: flex;
            height: 48px;
            width: 120px;
            padding: 12px 16px;
            justify-content: center;
            align-items: center;
            align-self: stretch;
            border-radius: 6px;
            background: var(--01-Primary-Primary-500, #1264D4) !important;
            font-size: 14px !important;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            cursor: pointer;
          }
          .vjs-question-set-footer-btn-secondary {
            color: var(--01-Primary-Primary-500, #1264D4) !important;
            border: 1px solid var(--01-Primary-Primary-500, #1264D4) !important;
            background: var(--Transparent, rgba(255, 255, 255, 0.00)) !important;
          }
          .vjs-question-set-progress-bar {
            display: flex;
            height: 4px;
            align-items: center;
            gap: 2px;
            flex: 1 0 0;
          }
          .vjs-question-set-progress-bar > .vjs-question-set-progress-tag {
            height: 4px;
            flex: 1 0 0;
            background: rgba(0, 0, 0, 0.15);
          }
          .vjs-question-set-progress-bar > .vjs-question-set-progress-tag-active {
              background: #1264D4;
          }
          .vjs-answer-wrong-field {
            border: 3px solid #BA160B !important;
            background: #F8E9E9;
          }
          .vjs-answer-correct-field {
             border: 3px solid #15B08E !important;
             background: #E7F9EF;
          }
          .error-text{
            margin-bottom: 8px;
            color: #BA160B;
            text-align: right;
            font-weight: bold;
            font-size: 14px;
            text-transform: uppercase;
          }
         .vjs-overlay-feedback {
            position: absolute;
            inset: 0px;
            background: rgba(255, 255, 255, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            font-size: 18px;
            color: black;
         }
      `));
    document.head.appendChild(stylesheet);

    /*
     * create top row
     */
    const topHeader = dom$4.createEl('div', {
      className: 'vjs-question-set-header'
    });
    const questionSetName = dom$4.createEl('h3', {
      innerHTML: this.questionSet.name
    });
    topHeader.append(questionSetName);
    const question = this.createQuestion();
    el.append(topHeader);
    question.forEach(e => el.append(e));
    el.append(this.createFooter());
    return el;
  }
  createButton(text, link = '#', action = null, properties) {
    const btnEl = dom$4.createEl('button', properties);
    btnEl.innerHTML = text;
    btnEl.addEventListener(DomEvents.CLICK, action);
    return btnEl;
  }
  createQuestion() {
    /* should create question row and question */
    const questionRow = dom$4.createEl('div', {
      className: 'vjs-question-set-row',
      id: 'sd-current-question-label'
    });
    const questionLabel = dom$4.createEl('span', {
      className: 'vjs-question-set-label',
      innerHTML: `${this.player.getLanguage('question')} ${this.questions.findIndex(e => e.id === this.currentQuestion.id) + 1}`
    });
    const questionString = dom$4.createEl('p', {
      className: 'vjs-question-set-question',
      innerHTML: this.currentQuestion.text
    });
    questionRow.append(questionLabel);
    questionRow.append(questionString);
    const answerRow = dom$4.createEl('div', {
      className: 'vjs-question-set-answer-row',
      id: 'sd-current-question-answer'
    });
    /*  depending on question type set the label */
    const answerRowLabelContainer = dom$4.createEl('div', {
      className: 'vjs-question-set-answer-label-container',
      id: 'vjs-question-set-answer-label-container-id'
    });
    const answerRowLabel = dom$4.createEl('span', {
      innerHTML: this.currentQuestion.type === 'FreeText' ? this.player.getLanguage('typeAnswer') : this.player.getLanguage('chooseAnswer'),
      className: 'vjs-question-set-answer-label'
    });
    answerRowLabelContainer.appendChild(answerRowLabel);
    answerRow.append(answerRowLabelContainer);
    const answerOptionsContainer = dom$4.createEl('div', {
      className: 'vjs-question-set-answer-options-container',
      id: 'vjs-question-set-answer-options-container-id'
    });
    // depending on question type create correspondend input

    if (this.currentQuestion && this.currentQuestion.type === 'MultipleChoice') {
      this.currentQuestion.answerOptions.forEach(option => {
        answerOptionsContainer.append(this.createRadioOrCheckboxInput(option.id, option.title, option.id, 'checkbox'));
      });
    }
    if (this.currentQuestion && this.currentQuestion.type === 'SingleChoice') {
      this.currentQuestion.answerOptions.forEach(option => {
        answerOptionsContainer.append(this.createRadioOrCheckboxInput(option.id, option.title, option.id, 'radio'));
      });
    }
    if (this.currentQuestion && this.currentQuestion.type === 'FreeText') {
      answerOptionsContainer.append(this.createFreeTextInput());
    }
    answerRow.appendChild(answerOptionsContainer);
    return [questionRow, answerRow];
  }
  createRadioOrCheckboxInput(answerId, name, value, type) {
    const container = dom$4.createEl('label', {
      className: 'vjs-question-set-input-wrapper',
      id: answerId,
      innerHTML: name
    });
    const inputEl = dom$4.createEl('input', {
      className: '.vjs-question-set-input-box vjs-input-field',
      type,
      checked: this.answerHistory.some(e => e.answers.includes(answerId)),
      name: this.currentQuestion.text,
      value,
      oninput: () => {
        const findElement = document.getElementById('error-text-id');
        if (findElement) {
          findElement.remove();
        }
      }
    });
    const customEl = dom$4.createEl('div', {
      className: 'vjs-question-set-input-wrapper-custom'
    });
    container.append(inputEl);
    container.append(customEl);
    return container;
  }
  createFreeTextInput(name) {
    const container = dom$4.createEl('div', {
      className: 'vjs-question-set-free-text-container'
    });
    const freeTextInput = dom$4.createEl('textarea', {
      className: 'vjs-question-set-free-text-input vjs-input-field',
      row: '5',
      name
    });
    container.append(freeTextInput);
    return container;
  }
  createFooter() {
    const container = dom$4.createEl('div', {
      className: 'vjs-question-set-footer',
      id: 'sd-current-question-footer'
    });
    const buttonRow = dom$4.createEl('div', {
      className: 'vjs-question-set-footer-btn-row'
    });
    const countBtn = dom$4.createEl('span', {
      className: 'vjs-question-set-footer-span',
      innerHTML: `<span id="current-question-index" style="font-weight: bold;">${this.currentIndex + 1}</span>/<span id="current-question-length">${this.questions.length}</span>`
    });
    buttonRow.append(countBtn);
    if (this.quizSettings.allowNavigation && this.currentQuestion.answerRequired === 'NotRequired' && this.currentIndex !== 0) {
      const prev = this.createButton(this.player.getLanguage('back'), '', () => {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.currentQuestion = this.questions[this.currentIndex];
          this.player.el_.appendChild(this.createEl());
        }
      }, {
        disabled: this.currentIndex === 0,
        className: 'vjs-question-set-footer-btn-secondary'
      });
      buttonRow.append(prev);
    }
    if (this.currentIndex < this.questions.length - 1) {
      const next = this.createButton(this.player.getLanguage('submit'), '', async () => {
        try {
          if (this.feedbackActive) {
            this.feedbackActive = false;
            this.currentIndex++;
            this.currentQuestion = this.questions[this.currentIndex];
            return this.player.el_.appendChild(this.createEl());
          }
          const submit = await this.submitAnswer();
          if (submit === 'success') {
            this.currentIndex++;
            this.currentQuestion = this.questions[this.currentIndex];
            return this.player.el_.appendChild(this.createEl());
          }
        } catch (e) {
          this.createAnswerInvalid(e.message);
        }
      }, {
        className: 'vjs-question-set-footer-btn-primary',
        id: 'sd-button-next'
      });
      buttonRow.append(next);
      if (this.quizSettings.allowNavigation && this.currentQuestion.answerRequired === 'NotRequired' && this.currentIndex < this.questions.length - 1) {
        const skip = this.createButton(this.player.getLanguage('skip'), '', async () => {
          if (this.currentIndex <= this.questions.length) {
            await this.answerQuestionQuery({
              skip: true,
              answers: [],
              freeTextAnswer: ''
            });
            this.currentIndex++;
            this.currentQuestion = this.questions[this.currentIndex];
            this.player.el_.appendChild(this.createEl());
          }
        }, {
          className: 'vjs-question-set-footer-btn-primary'
        });
        buttonRow.append(skip);
      }
    } else {
      const finish = this.createButton(this.player.getLanguage('next'), '', async () => {
        try {
          if (this.feedbackActive) {
            this.feedbackActive = false;
            await this.finishQuestionSet();
          } else {
            const submit = await this.submitAnswer();
            if (submit === 'success') {
              await this.finishQuestionSet();
            }
          }
        } catch (e) {
          this.createAnswerInvalid(e.message);
        }
      }, {
        className: 'vjs-question-set-footer-btn-primary'
      });
      buttonRow.append(finish);
    }

    /*
    missing option so will hide it for now
    const shrink = this.createButton('Shrink');
       buttonRow.append(shrink);
     */

    const progressBar = dom$4.createEl('div', {
      className: 'vjs-question-set-progress-bar'
    });
    this.questions.forEach(question => {
      /*
        if question is answered also add active state
       */
      if (this.currentQuestion.id === question.id || question.status === 'Answered' || this.answerHistory.some(e => e.questionId === question.id)) {
        progressBar.append(dom$4.createEl('div', {
          className: 'vjs-question-set-progress-tag vjs-question-set-progress-tag-active'
        }));
      } else {
        progressBar.append(dom$4.createEl('div', {
          className: 'vjs-question-set-progress-tag'
        }));
      }
    });
    container.append(buttonRow);
    container.append(progressBar);
    return container;
  }
  async finishQuestionSet() {
    let event;
    const questionSetEl = document.getElementById('question-set');
    if (questionSetEl) {
      document.getElementById('question-set').remove();
    }
    if (this.currentInteraction.options[0].sceneId) {
      event = new CustomEvent(StoryEvents.CHANGE_SOURCE, {
        bubbles: true,
        cancelable: true,
        detail: {
          id: this.currentInteraction.options[0].sceneId,
          interactionId: this.currentInteraction.id,
          type: 'redirect'
        }
      });
      return document.dispatchEvent(event);
    }
    await this.finishAttempt();
    event = new CustomEvent(QaEvents.FINISH_SUMMARY, {
      bubbles: true,
      cancelable: true,
      detail: {
        id: this.currentInteraction.options[0].sceneId,
        interactionId: this.currentInteraction.id,
        type: 'redirect'
      }
    });
    return document.dispatchEvent(event);
  }
  async submitAnswer() {
    if (this.currentQuestion.type === 'MultipleChoice' || this.currentQuestion.type === 'SingleChoice') {
      const answers = [];
      const inputElements = document.getElementsByClassName('vjs-input-field');
      for (let i = 0; inputElements[i]; ++i) {
        if (inputElements[i].checked) {
          answers.push(inputElements[i].value);
        }
      }
      if (this.currentQuestion.type === 'SingleChoice' && !answers.length) {
        this.createAnswerInvalid();
        return 'fail';
      }
      return await this.answerQuestionQuery({
        skip: false,
        answers,
        freeTextAnswer: ''
      });
    }
    if (this.currentQuestion.type === 'FreeText') {
      const freeTextAnswer = document.getElementsByClassName('vjs-input-field')[0].value;
      return this.answerQuestionQuery({
        skip: false,
        answers: [],
        freeTextAnswer
      });
    }
    const findEl = document.getElementById('question-set');
    if (findEl) {
      findEl.remove();
    }
    return 'success';
  }
  async answerQuestionQuery({
    answers,
    freeTextAnswer,
    skip
  }) {
    const fetchQuery = await fetch(`${this.apiUrl}/quizzes/${this.options.story.id}/attempts/${this.attempt.id}/questionsets/${this.questionSet.id}/question/${this.currentQuestion.id}/answer`, {
      method: 'PUT',
      headers: {
        'Authorization': this.options.token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        answers,
        freeTextAnswer,
        skip
      })
    });
    if (!fetchQuery.ok) {
      const errorData = await fetchQuery.json();
      throw new Error(`${errorData.message || this.player.getLanguage('somethingError')}`);
    }
    const responseBody = await fetchQuery.json();
    if (this.answerHistory.length) {
      const findIndexOfAnswered = this.answerHistory.findIndex(answer => answer.questionId === this.currentQuestion.id);
      if (findIndexOfAnswered >= 0) {
        this.answerHistory.splice(findIndexOfAnswered, 1, {
          questionId: this.currentQuestion.id,
          answers
        });
      } else {
        this.answerHistory.push({
          questionId: this.currentQuestion.id,
          answers
        });
      }
    } else {
      this.answerHistory.push({
        questionId: this.currentQuestion.id,
        answers
      });
    }
    if (responseBody.data.feedbackText) {
      if (responseBody.data.isCorrect !== null) {
        this.createFeedbackOverlay({
          success: responseBody.data.isCorrect,
          text: responseBody.data.feedbackText,
          id: 'vjs-question-set-answer-options-container-id'
        });
        return 'false';
      }
    } else {
      return 'success';
    }
  }
  async finishAttempt() {
    const finishCurAttemptQuery = await fetch(`${this.apiUrl}/quizzes/${this.options.story.id}/attempts/${this.attempt.id}/finish`, {
      method: 'POST',
      headers: {
        Authorization: this.options.token
      }
    });
    if (!finishCurAttemptQuery.ok) {
      const errorData = await finishCurAttemptQuery.json();
      throw new Error(`${errorData.message || this.player.getLanguage('somethingError')}`);
    }
    const finishAttemptPayload = await finishCurAttemptQuery.json();
    if (finishAttemptPayload.status === 'success') {
      return finishAttemptPayload.data;
    }
  }
  createAnswerInvalid(text) {
    if (!document.getElementById('error-text-id')) {
      const findEl = document.getElementById('vjs-question-set-answer-label-container-id');
      const errorTextNode = dom$4.createEl('span', {
        innerHTML: text ? text : this.player.getLanguage('noAnswerSelected'),
        className: 'error-text',
        id: 'error-text-id'
      });
      findEl.append(errorTextNode);
    }
  }
  async show() {
    this.player.pause();
    this.player.el_.appendChild(this.createEl());
  }
  createFeedbackOverlay({
    success,
    text,
    id
  }) {
    // define type whether it was an error or not
    this.feedbackActive = true;
    const overlayDiv = dom$4.createEl('div', {
      className: 'vjs-overlay-feedback',
      innerHTML: text
    });
    document.getElementById(id).style = 'overflow-y: hidden;';
    document.getElementById(id).append(overlayDiv);
    const nextButton = document.getElementById('sd-button-next');
    if (nextButton) {
      nextButton.innerText = this.player.getLanguage('next');
    }
    const questionSetAnswerRowElement = document.getElementById('sd-current-question-answer');
    if (questionSetAnswerRowElement) {
      questionSetAnswerRowElement.classList.add(success ? 'vjs-answer-correct-field' : 'vjs-answer-wrong-field');
    }
    return false;
  }
}

const dom$3 = videojs.dom || videojs;
class SdQaSummary {
  constructor(player, options, attemptSummary, quizSettings) {
    this.player = player;
    this.player.controls(false);
    this.options = options;
    this.apiUrl = options.apiUrl;
    this.attemptSummary = attemptSummary;
    this.quizSettings = quizSettings;
    /* title, description,
         options: { title: string, sceneId: string, type: redirect or continue} */
    if (attemptSummary) {
      this.show();
    }
  }
  createEl() {
    const findEl = document.getElementById('vjs-question-set-summary');
    if (findEl) {
      findEl.remove();
    }
    const el = dom$3.createEl('div', {
      className: 'vjs-question-set-summary',
      id: 'vjs-question-set-summary'
    });

    /*
     * create top row
     */
    const topHeader = this.createTopHeader();
    el.append(topHeader);
    if (this.quizSettings.showQuestions) {
      const qaDetails = this.createQaDetails();
      el.append(qaDetails);
    }
    return el;
  }
  createTopHeader() {
    const topHeader = dom$3.createEl('div', {
      className: 'vjs-question-set-summary-header'
    });
    const summaryTitle = dom$3.createEl('h5', {
      innerText: 'Q&A Summary',
      className: 'vjs-question-summary-title'
    });
    topHeader.append(summaryTitle);
    const resultRow = dom$3.createEl('div', {
      className: 'vjs-question-summary-row'
    });
    const resultLabel = this.quizSettings.showResult && this.createLabel({
      name: this.player.getLanguage('result'),
      valueName: `<span
          class="vjs-question-summary-label-circle ${this.attemptSummary.passed ? 'passed' : 'failed'}" >${this.attemptSummary.passed ? '&#10003;' : '<svg width="18" height="18" fill="#BA160B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></>'}</span> <span>${this.attemptSummary.passed ? this.player.getLanguage('passed') : this.player.getLanguage('failed')}</span>`,
      customNameClass: 'white-text',
      customClass: `result ${this.attemptSummary.passed ? 'passed' : 'failed'}`
    });
    const scoreLabel = this.quizSettings.showScore && this.createLabel({
      name: this.player.getLanguage('score'),
      valueName: `${this.attemptSummary.rate}%`
    });
    const attemptsLabel = this.quizSettings.attemptCountLimit && this.createLabel({
      name: this.player.getLanguage('attempts'),
      valueName: `${this.attemptSummary.attemptNumber} ${this.player.getLanguage('of')} ${this.quizSettings.attemptCountLimit}`,
      customClass: 'attempts'
    });
    const tryAgainButton = (this.attemptSummary.attemptNumber < this.quizSettings.attemptCountLimit || !this.quizSettings.attemptCountLimit) && this.createLabel({
      name: this.player.getLanguage('clickHereTo'),
      valueName: this.player.getLanguage('tryAgain'),
      event: () => {
        const findEl = document.getElementById('vjs-question-set-summary');
        if (findEl) {
          findEl.remove();
        }
        const event = new CustomEvent(StoryEvents.STORY_RESTART, {
          bubbles: true,
          cancelable: true
        });
        document.dispatchEvent(event);
      }
    });
    [resultLabel, scoreLabel, attemptsLabel, tryAgainButton].filter(el => el).forEach(label => resultRow.appendChild(label));
    topHeader.appendChild(resultRow);
    return topHeader;
  }
  createQaDetails() {
    const createDetailsContainer = dom$3.createEl('div', {
      className: 'vjs-question-summary-details-container'
    });
    const detailsTitle = dom$3.createEl('h6', {
      innerText: 'Q&A Details',
      className: 'vjs-question-summary-details-title'
    });
    createDetailsContainer.appendChild(detailsTitle);
    if (this.quizSettings.showCorrectAnswers) {
      const legendRow = dom$3.createEl('div', {
        className: 'vjs-question-summary-details-legend-row'
      });
      const rightSelectionPill = this.createLabel({
        valueName: `<div class="vjs-question-summary-details-legend-pill-content correct"><div class="circle correct" > </div> <span>${this.player.getLanguage('rightSelection')}</span></div>`,
        pill: true,
        customClass: 'correct'
      });
      const wrongSelectionPill = this.createLabel({
        valueName: `<div class="vjs-question-summary-details-legend-pill-content"><div class="circle incorrect"> </div> <span>${this.player.getLanguage('wrongSelection')}</span></div>`,
        pill: true,
        customClass: 'incorrect'
      });
      const ungradedPill = this.attemptSummary.questions.some(e => e.type === 'FreeText') && this.createLabel({
        valueName: `<div class="vjs-question-summary-details-legend-pill-content ungraded"><div class="circle ungraded"> </div> <span>${this.player.getLanguage('ungraded')}</span></div>`,
        pill: true,
        customClass: 'ungraded'
      });
      const correctAnswerPill = this.createLabel({
        valueName: `<div class="vjs-question-summary-details-legend-pill-content"><div class="circle check">&#10003;</div> <span>${this.player.getLanguage('correctAnswers')}</span></div>`,
        pill: true
      });
      [rightSelectionPill, wrongSelectionPill, ungradedPill, correctAnswerPill].filter(e => e).forEach(pill => legendRow.appendChild(pill));
      createDetailsContainer.appendChild(legendRow);
    }
    this.attemptSummary.questions.forEach((question, index) => {
      const mergedObj = question;
      mergedObj.number = index + 1;
      createDetailsContainer.appendChild(this.createQuestionResult(mergedObj));
    });
    return createDetailsContainer;
  }
  createLabel({
    name,
    valueName,
    event,
    customClass,
    customNameClass,
    pill
  }) {
    const labelDiv = dom$3.createEl(event ? 'button' : 'div', {
      className: `${pill ? 'vjs-question-summary-pill' : 'vjs-question-summary-label'} ${customClass ? customClass : ''}`
    });
    if (event) {
      labelDiv.addEventListener(DomEvents.CLICK, event);
    }
    if (name) {
      const nameTag = dom$3.createEl('span', {
        innerText: name,
        className: `vjs-question-summary-label-name ${customNameClass ? customNameClass : ''}`
      });
      labelDiv.appendChild(nameTag);
    }
    if (valueName) {
      const value = dom$3.createEl('div', {
        innerHTML: valueName,
        className: pill ? '' : 'vjs-question-summary-label-value'
      });
      labelDiv.appendChild(value);
    }
    return labelDiv;
  }
  createQuestionResult({
    number,
    text,
    feedback,
    answerOptions,
    givenAnswers,
    type,
    freeTextAnswer
  }) {
    const showCorrectAnswers = this.quizSettings.showCorrectAnswers;
    const answeredCorrectly = type === 'SingleChoice' ? givenAnswers.some(e => e.isCorrect) : answerOptions && givenAnswers && answerOptions.filter(e => e.isCorrect).length === givenAnswers.filter(e => e.isCorrect).length;
    const createQuestionContainer = dom$3.createEl('div', {
      className: `vjs-question-summary-details-question-container ${answeredCorrectly && showCorrectAnswers ? 'vjs-summary-correct' : type === 'FreeText' || !showCorrectAnswers ? 'vjs-summary-ungraded' : 'vjs-summary-wrong'}`
    });
    const questionLabelRow = dom$3.createEl('div', {
      className: 'vjs-question-summary-details-question-header-row',
      innerHTML: `<span class="vjs-question-summary-details-question-number">${number}</span> <span>${text}</span>`
    });
    createQuestionContainer.appendChild(questionLabelRow);
    const answerOptionsContainer = dom$3.createEl('ul', {
      className: 'vjs-question-summary-details-answer-list'
    });
    if (freeTextAnswer) {
      const createText = dom$3.createEl('li', {
        className: 'vjs-question-details-answer',
        innerHTML: `<span>${freeTextAnswer}</span>`
      });
      answerOptionsContainer.appendChild(createText);
    }
    answerOptions.forEach(answerOption => {
      const selectedAnswer = givenAnswers.find(e => e.id === answerOption.id);
      const createOption = dom$3.createEl('li', {
        className: `vjs-question-details-answer ${selectedAnswer && typeof selectedAnswer.isCorrect === 'boolean' ? selectedAnswer.isCorrect ? 'vjs-question-details-answer-correct' : 'vjs-question-details-answer-wrong' : selectedAnswer && selectedAnswer.isCorrect === null ? 'vjs-question-details-answer-ungraded' : ''}`,
        innerHTML: `${showCorrectAnswers && answerOption.isCorrect ? '<div class="vjs-question-details-answer-correct-checkmark">&#10003;</div>' : ''}<span>${answerOption.title}</span>`
      });
      answerOptionsContainer.appendChild(createOption);
    });
    createQuestionContainer.appendChild(answerOptionsContainer);
    if (this.quizSettings.showQuestionFeedbackText && feedback) {
      const overlayDiv = dom$3.createEl('div', {
        className: 'vjs-feedback',
        innerHTML: `<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="rgba(0, 0, 0, 0.33)" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l96 0 0 80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0z"/></svg> ${feedback}`
      });
      createQuestionContainer.appendChild(overlayDiv);
    }
    return createQuestionContainer;
  }
  async show() {
    this.player.pause();
    this.player.el_.appendChild(this.createEl());
  }
}

function disposeInteractionOverlayStyles(player, singleId, multipleStylesheets) {
  player.on(PlayerEvents.DISPOSE, () => {
    if (singleId && document.getElementById(singleId)) {
      document.getElementById(singleId).remove();
    } else {
      if (singleId) {
        if (document.getElementById('stylesheet-' + singleId)) {
          document.getElementById('stylesheet-' + singleId).remove();
        }
      }
      if (multipleStylesheets && multipleStylesheets.length) {
        for (const stylesheetId of multipleStylesheets) {
          if (document.getElementById('stylesheet-' + stylesheetId)) {
            document.getElementById('stylesheet-' + stylesheetId).remove();
          }
        }
      }
    }
  });
}

const dom$2 = videojs.dom || videojs;
class SdInteraction {
  constructor(player, options, interaction, backwardsNavigation, attempt) {
    this.player = player;
    this.options = options;
    this.interaction = interaction;
    this.player.setState({
      disableControls: true
    });
    this.apiUrl = options.apiUrl;
    this.currentQuestionSet = null;
    this.attempt = attempt;
    this.questionSetAttempt = null;
    this.quizSettings = null;
    this.backwardsNavigation = backwardsNavigation;
    /* title, description,
         options: { title: string, sceneId: string, type: redirect or continue} */
    this.show();
    document.addEventListener(QaEvents.FINISH_SUMMARY, async () => {
      if (this.quizSettings && this.quizSettings.showSummary) {
        await this.createSummary();
      } else {
        this.player.setState({
          disableControls: false
        });
      }
    }, {
      once: true
    });
    disposeInteractionOverlayStyles(this.player, this.interaction.id);
  }
  async createEl() {
    let el = dom$2.createEl('div', {
      className: 'vjs-interaction',
      id: 'current-interaction'
    });
    if (this.interaction.options && this.interaction.options.length > 1) {
      if (this.interaction.css) {
        const styleObj = JSON.parse(this.interaction.css);
        let stringClass = '';
        for (let i = 0; i < Object.values(styleObj).length; i++) {
          stringClass += Object.values(styleObj)[i] + '\r\n';
        }
        const stylesheet = dom$2.createEl('style');
        stylesheet.type = 'text/css';
        // const getString
        stylesheet.setAttribute('id', this.interaction.id);
        if (stylesheet.styleSheet) {
          // This is required for IE8 and below.
          stylesheet.styleSheet.cssText = stringClass;
        } else {
          stylesheet.appendChild(document.createTextNode(`
          ${stringClass}
      `));
          document.head.appendChild(stylesheet);
        }
      }
      const titleEl = dom$2.createEl('h1');
      titleEl.setAttribute('class', 'title');
      titleEl.innerHTML = this.interaction.title;
      let descriptionEl;
      if (this.interaction.description) {
        descriptionEl = dom$2.createEl('p');
        descriptionEl.setAttribute('class', 'description');
        descriptionEl.innerHTML = this.interaction.description;
      }
      const actionWrapperEl = dom$2.createEl('div', {
        className: 'vjs-sd-action-wrapper'
      });
      const sortedOptions = this.interaction.options.sort((a, b) => new Date(a.audit.createdAtUtc) - new Date(b.audit.createdAtUtc));
      for (let i = 0; i < this.interaction.options.length; i++) {
        const option = sortedOptions[i];
        let btnEl = null;
        switch (option.type) {
          case 'redirect':
            {
              btnEl = this.createButton(option.text, '#', () => {
                this.hide();
                const event = new CustomEvent(StoryEvents.CHANGE_SOURCE, {
                  bubbles: true,
                  cancelable: true,
                  detail: {
                    id: option.sceneId,
                    interactionId: this.interaction,
                    type: 'redirect'
                  }
                });
                document.dispatchEvent(event);
              });
              break;
            }
          case 'continue':
            {
              btnEl = this.createButton(option.text, '#', () => {
                this.hide();
                const event = new CustomEvent(StoryEvents.CHANGE_SOURCE, {
                  bubbles: true,
                  cancelable: true,
                  detail: {
                    type: 'continue',
                    interactionId: this.interaction.id
                  }
                });
                document.dispatchEvent(event);
              });
              break;
            }
          default:
            {
              btnEl = this.createButton(option.text, '#', () => {
                this.hide();
                const event = new CustomEvent(StoryEvents.CHANGE_SOURCE, {
                  bubbles: true,
                  cancelable: true,
                  detail: {
                    type: 'continue',
                    interactionId: this.interaction.id
                  }
                });
                document.dispatchEvent(event);
              });
              break;
            }
        }
        actionWrapperEl.appendChild(btnEl);
      }
      if (this.backwardsNavigation) {
        const restartBtn = dom$2.createEl('a', {
          href: '#',
          target: '_self',
          className: 'sd-restart-button'
        });
        restartBtn.innerHTML = this.player.getLanguage('previous');
        restartBtn.addEventListener(DomEvents.CLICK, () => {
          this.hide();
          const event = new CustomEvent(StoryEvents.CHANGE_SOURCE, {
            bubbles: true,
            cancelable: true,
            detail: {
              type: 'previous',
              interactionId: this.interaction.id
            }
          });
          document.dispatchEvent(event);
        });
        el.appendChild(restartBtn);
      }

      // sd-restart-button
      el.appendChild(titleEl);
      if (descriptionEl) {
        el.appendChild(descriptionEl);
      }
      el.appendChild(actionWrapperEl);
    } else if (this.interaction.options && this.interaction.options.length === 1 && this.interaction.options[0].sceneId && !this.interaction.questionSetId) {
      const event = new CustomEvent(StoryEvents.CHANGE_SOURCE, {
        bubbles: true,
        cancelable: true,
        detail: {
          type: 'redirect',
          id: this.interaction.options[0].sceneId
        }
      });
      document.dispatchEvent(event);
    } else {
      try {
        if (!this.attempt) {
          await this.createQaAttempt();
        }
        await this.getQuestionSetAttempt();
        await this.getQuizSettings();
        this.currentQuestionSet = new SdQuestionSet(this.player, this.options, this.questionSetAttempt, this.attempt, this.quizSettings, this.interaction);
        el = null;
      } catch (e) {
        SdInteraction.createToast(e.message, false, this.player);
      }
    }
    return el;
  }
  createButton(text, link = '#', action = null) {
    if (this.interaction.focusType === 'interaction') {
      const btnEl = dom$2.createEl('a', {
        className: 'vjs-sd-action-wrapper_btn interaction-btn'
      });
      btnEl.innerHTML = text;
      return btnEl;
    }
    const btnEl = dom$2.createEl('a', {
      href: link,
      target: link === '#' ? '_self' : '_blank',
      className: 'vjs-sd-action-wrapper_btn interaction-btn'
    });
    btnEl.innerHTML = text;
    btnEl.addEventListener(DomEvents.CLICK, action);
    return btnEl;
  }
  async createQaAttempt() {
    const createNewAttempt = await fetch(`${this.apiUrl}/quizzes/${this.options.story.id}/attempts${this.options.story.isEditor ? '?demoAttempt=true' : ''}`, {
      method: 'POST',
      headers: {
        Authorization: this.options.token
      }
    });
    if (!createNewAttempt.ok) {
      const errorData = await createNewAttempt.json();
      throw new Error(`${errorData.message || this.player.getLanguage('createQuestionAttemptError')}`);
    }
    const newAttemptPayload = await createNewAttempt.json();
    this.attempt = newAttemptPayload.data;
    const event = new CustomEvent(QaEvents.ADD_ATTEMPT, {
      bubbles: true,
      cancelable: true,
      detail: {
        attempt: newAttemptPayload.data
      }
    });
    document.dispatchEvent(event);
  }
  async getQuestionSetAttempt() {
    const fetchQuery = await fetch(`${this.apiUrl}/quizzes/${this.options.story.id}/attempts/${this.attempt.id}/questionsets/${this.interaction.questionSetId}`, {
      method: 'GET',
      headers: {
        Authorization: this.options.token
      }
    });
    if (!fetchQuery.ok) {
      const errorData = await fetchQuery.json();
      throw new Error(`${errorData.message || this.player.getLanguage('fetchQuestionAttemptError')}`);
    }
    const responseBody = await fetchQuery.json();
    this.questionSetAttempt = responseBody.data;
  }
  async getQuizSettings() {
    const fetchQuery = await fetch(`${this.apiUrl}/quizzes/${this.options.story.id}`, {
      method: 'GET',
      headers: {
        Authorization: this.options.token
      }
    });
    if (!fetchQuery.ok) {
      const errorData = await fetchQuery.json();
      throw new Error(`${errorData.message || this.player.getLanguage('fetchQuizSettingsError')}`);
    }
    const responseBody = await fetchQuery.json();
    this.quizSettings = responseBody.data;
  }
  hide() {
    if (document.getElementById(this.interaction.id)) {
      document.getElementById(this.interaction.id).remove();
    }
    if (document.querySelector('.vjs-interaction') !== null) {
      document.querySelector('.vjs-interaction').remove();
    }
    return this;
  }
  async createSummary() {
    try {
      const getSummaryQuery = await fetch(`${this.apiUrl}/quizzes/${this.options.story.id}/attempts/${this.attempt.id}`, {
        method: 'GET',
        headers: {
          Authorization: this.options.token
        }
      });
      if (!getSummaryQuery.ok) {
        const errorData = await getSummaryQuery.json();
        throw new Error(`${errorData.message || this.player.getLanguage('fetchQuestionSummaryError')}`);
      }
      const responseData = await getSummaryQuery.json();
      const summary = responseData.data;
      if (summary) {
        const newSummary = new SdQaSummary(this.player, this.options, summary, this.quizSettings);
        await newSummary.show();
      }
    } catch (e) {
      SdInteraction.createToast(e.message, false, this.player);
    }
  }
  async show() {
    this.player.pause();
    const interactionEl = await this.createEl();
    if (interactionEl) {
      this.player.el_.appendChild(interactionEl);
    }
  }
  static createToast(text, isCorrect, player) {
    const toastElement = dom$2.createEl('div', {
      className: `vjs-toast ${isCorrect ? 'vjs-toast-success' : 'vjs-toast-fail'}`,
      id: 'sd-toast-notification',
      innerHTML: `<span>${text}</span>`
    });
    player.el_.appendChild(toastElement);
    setTimeout(() => {
      const findEl = document.getElementById('sd-toast-notification');
      if (findEl) {
        findEl.classList.add('show');
      }
    }, 100);
    setTimeout(() => {
      const findEl = document.getElementById('sd-toast-notification');
      if (findEl) {
        findEl.classList.remove('show');
      }
    }, 10000);
    setTimeout(() => {
      const findEl = document.getElementById('sd-toast-notification');
      if (findEl) {
        findEl.remove();
      }
    }, 12000);
  }
}

async function fetchWithAuthentication(url, token) {
  const headers = new Headers();
  headers.set('Authorization', token);
  return await fetch(url, {
    headers
  });
}
async function displayProtectedImage(el, url, token) {
  const getImage = await fetchWithAuthentication(url, token);
  const responseBlob = await getImage.blob();
  const objectUrl = URL.createObjectURL(responseBlob);
  el.src = objectUrl;
  el.onload = () => URL.revokeObjectURL(objectUrl);
}

const dom$1 = videojs.dom || videojs;
class SdOverlay {
  constructor(player, options, overlay) {
    this.player = player;
    this.options = options;
    this.overlay = overlay;
    /* title, description,
             options: { title: string, entryId: string, type: redirect or continue} */
    disposeInteractionOverlayStyles(this.player, this.overlay.id);
    this.show();
  }
  async createEl() {
    const {
      type,
      text,
      url,
      css,
      id
    } = this.overlay;
    if (css) {
      const styleObj = JSON.parse(css);
      let stringClass = '';
      for (let i = 0; i < Object.values(styleObj).length; i++) {
        stringClass += Object.values(styleObj)[i] + '\r\n';
      }
      const stylesheet = dom$1.createEl('style');
      stylesheet.type = 'text/css';
      // const getString
      stylesheet.setAttribute('id', 'stylesheet-' + id);
      if (stylesheet.styleSheet) {
        // This is required for IE8 and below.
        stylesheet.styleSheet.cssText = stringClass;
      } else {
        stylesheet.appendChild(document.createTextNode(`
                      ${stringClass}
                `));
        document.head.appendChild(stylesheet);
      }
    }
    let el;
    if (type === 'text') {
      el = dom$1.createEl('p', {
        className: `overlay-${this.overlay.id}`,
        id
      });
      el.innerText = text;
    }
    if (type === 'link') {
      el = dom$1.createEl('a', {
        href: url,
        target: '_blank',
        className: `overlay-${this.overlay.id}`,
        id
      });
      el.innerHTML = text;
    }
    if (type === 'image') {
      // fetch with authentication
      el = dom$1.createEl('img', {
        id,
        className: `overlay-${this.overlay.id}`
      });
      await displayProtectedImage(el, url, this.options.token);
    }
    return el;
  }
  hide() {
    if (document.getElementById(this.overlay.id)) {
      document.getElementById(this.overlay.id).remove();
    }
    return this;
  }
  async show() {
    this.player.el_.appendChild(await this.createEl());
  }
}

const dom = videojs.dom || videojs;
class SdStory {
  constructor(player, plugin, options) {
    this.story = options.story;
    this.player = player;
    this.options = options;
    this.currentChapter = null;
    this.focusedInteraction = null;
    this.pastOverlays = [];
    this.interactionHistory = [];
    this.interactionHistoryOfScene = [];
    this.attempt = null;
    if (this.story && this.story.scenes) {
      this.selectedScene = this.story.scenes[0];
    }
    this.player.on(PlayerEvents.TIMEUPDATE, () => {
      /*
        if tolerance is not accepted then also see if videojs duration is the same as end and listen to end listener
       */
      this.updatedTime();
    });
    this.player.on(PlayerEvents.SEEKING, () => {
      if (this.focusedInteraction && this.player.currentTime() !== this.focusedInteraction.start / 1000) {
        this.player.currentTime(this.focusedInteraction.start / 1000);
        this.player.pause();
      }
    });
    this.player.on(PlayerEvents.SEEKED, () => {
      if (this.focusedInteraction) {
        this.player.pause();
      }
    });
    disposeInteractionOverlayStyles(this.player, this.focusedInteraction && this.focusedInteraction.id, this.selectedScene && this.selectedScene.overlays);
    document.addEventListener(StoryEvents.CHANGE_SOURCE, event => {
      if (event.detail) {
        if (event.detail.type === 'redirect') {
          this.interactionHistory.push(event.detail.interaction);
          const findScene = this.story.scenes.find(e => e.id === event.detail.id);
          if (findScene) {
            if (this.selectedScene.overlays.length > 0) {
              this.pastOverlays = this.selectedScene.overlays;
            }
            this.selectedScene = findScene;
            // remove overlays that are still present
            this.player.currentTime(0);
            this.player.src(findScene.section.source);
            const findInteractionAt0 = this.selectedScene.interactions.find(e => e.start === 0);
            if (!findInteractionAt0) {
              this.player.play();
            }
            this.focusedInteraction = null;
            this.player.setState({
              disableControls: false
            });
            this.interactionHistoryOfScene = [];
          }
        }
        if (event.detail.type === 'continue') {
          this.interactionHistory.push(event.detail.interaction);
          if (this.player.duration() === this.player.currentTime()) {
            this.player.currentTime(0);
          }
          this.interactionHistoryOfScene.push(event.detail.interactionId);
          if (document.getElementById(this.focusedInteraction.id)) {
            document.getElementById(this.focusedInteraction.id).remove();
          }
          this.focusedInteraction = null;
          this.player.setState({
            disableControls: false
          });
          if (document.querySelector('.vjs-interaction') !== null) {
            document.querySelector('.vjs-interaction').remove();
          }
          this.player.play();
        }
        if (event.detail.type === 'previous') {
          if (this.selectedScene.overlays.length > 0) {
            for (const overlay of this.selectedScene.overlays) {
              const exists = document.getElementById(overlay.id);
              if (exists) {
                exists.remove();
              }
              const stylesheetExists = document.getElementById('stylesheet-' + overlay.id);
              if (stylesheetExists) {
                stylesheetExists.remove();
              }
            }
          }
          if (this.interactionHistory.length) {
            const selectedInteraction = this.interactionHistory[this.interactionHistory.length - 1];
            const findScene = this.story.scenes.find(scene => scene.id === selectedInteraction.sceneId);
            if (findScene.id !== this.selectedScene.id) {
              this.selectedScene = findScene;
              this.player.src(findScene.section.source);
            }
            this.player.currentTime(selectedInteraction.start);
            this.createInteraction(selectedInteraction);
            this.interactionHistory.splice(this.interactionHistory.length - 1, 1);
          } else {
            this.player.currentTime(0);
            this.player.play();
            this.focusedInteraction = null;
            this.player.setState({
              disableControls: false
            });
          }
        }
      } else {
        if (this.player.duration() === this.player.currentTime()) {
          this.player.currentTime(0);
        }
        this.focusedInteraction = null;
        this.player.setState({
          disableControls: false
        });
        this.player.play();
      }
    });
    document.addEventListener(StoryEvents.STORY_RESTART, () => {
      this.restart();
    });
    document.addEventListener(QaEvents.ADD_ATTEMPT, event => {
      if (event.detail) {
        this.attempt = event.detail.attempt;
      }
    });
  }
  createRestartButton() {
    const btnEl = dom.createEl('a', {
      className: 'sd-restart-button',
      href: '#'
    });
    btnEl.innerHTML = 'restart';
    btnEl.addEventListener(DomEvents.CLICK, () => {
      const event = new CustomEvent(StoryEvents.STORY_RESTART, {
        bubbles: true,
        cancelable: true
      });
      if (event) {
        document.dispatchEvent(event);
      }
    });
    return btnEl;
  }
  updatedTime() {
    const time = this.player.currentTime();
    const interactions = [...this.selectedScene.interactions].sort((a, b) => a.start > b.start ? 1 : -1);
    const overlays = this.selectedScene.overlays;
    if (!this.focusedInteraction) {
      for (let i = 0; i < interactions.length; i++) {
        const selected = interactions[i];
        if (!this.focusedInteraction && !this.interactionHistoryOfScene.includes(selected.id) && (!selected.start || time >= selected.start / 1000 || selected.start / 1000 > time && time >= (selected.start - 800) / 1000 && !selected.end && i === interactions.length - 1 || time >= (selected.start - 800) / 1000 && time <= selected.end / 1000)) {
          this.focusedInteraction = selected;
          if (document.getElementById(selected.id)) {
            document.getElementById(selected.id).remove();
          }
          if (document.querySelector('.vjs-interaction') !== null) {
            document.querySelector('.vjs-interaction').remove();
          }
          this.createInteraction(selected);
          break;
        }
      }
    }
    if (overlays.length > 0) {
      for (const overlay of overlays) {
        if (time >= overlay.start / 1000 && (!overlay.end || time <= overlay.end / 1000)) {
          if (!document.getElementById(overlay.id)) {
            this.createOverlay(overlay);
          }
        }
        if (overlay.start / 1000 > time || overlay.end / 1000 < time) {
          if (document.getElementById(overlay.id)) {
            document.getElementById(overlay.id).remove();
            document.getElementById('stylesheet-' + overlay.id).remove();
          }
        }
      }
    }
    if (this.pastOverlays.length > 0) {
      for (const overlay in this.pastOverlays) {
        const exists = document.getElementById(this.pastOverlays[overlay].id);
        if (exists) {
          exists.remove();
          document.getElementById('stylesheet-' + exists.id).remove();
        }
      }
    }
  }
  createInteraction(interaction) {
    this.currentChapter = new SdInteraction(this.player, this.options, interaction, this.story.backwardsNavigationEnabled, this.attempt);
  }
  createOverlay(overlay) {
    this.currentOverlay = new SdOverlay(this.player, this.options, overlay);
  }
  restart() {
    this.focusedInteraction = null;
    this.pastOverlays = [];
    this.interactionHistory = [];
    this.currentChapter = null;
    this.interactionHistoryOfScene = [];
    this.attempt = null;
    this.player.setState({
      disableControls: false
    });
    if (this.story && this.story.scenes) {
      this.selectedScene = this.story.scenes[0];
    }
    this.player.src(this.story.scenes[0].section.source);
    this.player.pause();
    this.player.currentTime(0);
  }
  doNothing() {}
}

var instructions$1 = "Click to start video";
var auto$1 = "auto";
var quality$1 = "Quality";
var speed$1 = "Speed";
var subtitles$1 = "Subtitels";
var settings$1 = "settings";
var on$1 = "on";
var off$1 = "off";
var subtitlesOff$1 = "Subtitles off";
var previous$1 = "previous";
var noAnswerSelected$1 = "No answer selected";
var Automatic$1 = "Automatic";
var Instructions$1 = "Click to start video";
var question$1 = "Question";
var back$1 = "Back";
var next$1 = "Next";
var skip$1 = "Skip";
var submit$1 = "Submit";
var chooseAnswer$1 = "Choose an answer";
var typeAnswer$1 = "Type your answer";
var somethingError$1 = "Something went wrong";
var qaSummary$1 = "Q&A Summary";
var passed$1 = "Passed";
var failed$1 = "Failed";
var result$1 = "Result";
var score$1 = "Score";
var attempts$1 = "Attempts";
var expiresIn$1 = "Expires in";
var clickHereTo$1 = "Click here to";
var tryAgain$1 = "Try again";
var rightSelection$1 = "Correctly answered";
var wrongSelection$1 = "Incorrectly answered";
var ungraded$1 = "Ungraded";
var correctAnswers$1 = "Correct Answer(s)";
var of$1 = "of";
var createQuestionAttemptError$1 = "Question attempt could not be created.";
var fetchQuestionSetError$1 = "Question set could not be retrieved.";
var fetchQuestionAttemptError$1 = "Question attempt could not be retrieved.";
var fetchQuizSettingsError$1 = "Question settings could not be retrieved.";
var fetchQuestionSummaryError$1 = "Question Summary could not be retrieved.";
var En = {
	instructions: instructions$1,
	auto: auto$1,
	quality: quality$1,
	speed: speed$1,
	subtitles: subtitles$1,
	settings: settings$1,
	on: on$1,
	off: off$1,
	subtitlesOff: subtitlesOff$1,
	previous: previous$1,
	noAnswerSelected: noAnswerSelected$1,
	"Include your own strings in JSON files.": "Include your own strings in JSON files.",
	Automatic: Automatic$1,
	Instructions: Instructions$1,
	question: question$1,
	back: back$1,
	next: next$1,
	skip: skip$1,
	submit: submit$1,
	chooseAnswer: chooseAnswer$1,
	typeAnswer: typeAnswer$1,
	somethingError: somethingError$1,
	qaSummary: qaSummary$1,
	passed: passed$1,
	failed: failed$1,
	result: result$1,
	score: score$1,
	attempts: attempts$1,
	expiresIn: expiresIn$1,
	clickHereTo: clickHereTo$1,
	tryAgain: tryAgain$1,
	rightSelection: rightSelection$1,
	wrongSelection: wrongSelection$1,
	ungraded: ungraded$1,
	correctAnswers: correctAnswers$1,
	of: of$1,
	createQuestionAttemptError: createQuestionAttemptError$1,
	fetchQuestionSetError: fetchQuestionSetError$1,
	fetchQuestionAttemptError: fetchQuestionAttemptError$1,
	fetchQuizSettingsError: fetchQuizSettingsError$1,
	fetchQuestionSummaryError: fetchQuestionSummaryError$1
};

var instructions = "Hier klicken um das Video abzuspielen";
var auto = "auto";
var quality = "Qualität";
var speed = "Geschwindigkeit";
var subtitles = "Untertitel";
var settings = "Einstellungen";
var on = "an";
var off = "aus";
var subtitlesOff = "Untertitel aus";
var previous = "vorherig";
var noAnswerSelected = "Bitte Antwort auswählen";
var Automatic = "Automatisch";
var Instructions = "Klicken hier um das Video abzuspielen";
var question = "Frage";
var back = "Zurück";
var next = "Weiter";
var skip = "Überspringen";
var submit = "Senden";
var chooseAnswer = "Wähle eine Antwort";
var typeAnswer = "Antwort eingeben";
var somethingError = "Etwas ist schiefgelaufen";
var qaSummary = "Q&A Zusammenfassung";
var passed = "Bestanden";
var failed = "Durchgefallen";
var result = "Ergebnis";
var score = "Punktezahl";
var attempts = "Versuche";
var expiresIn = "Läuft ab in";
var clickHereTo = "hier klicken um zu";
var tryAgain = "Wiederholen";
var rightSelection = "Richtig beantwortet";
var wrongSelection = "Falsch beantwortet";
var ungraded = "Nicht beurteilt";
var correctAnswers = "Richtige Antworten";
var of = "von";
var createQuestionAttemptError = "Quiz-Versuch konnte nicht erstellt werden.";
var fetchQuestionSetError = "Fragenkatalog konnte nicht abgerufen werden.";
var fetchQuestionAttemptError = "Quiz-Versuch konnte nicht abgerufen werden.";
var fetchQuizSettingsError = "Quiz-Einstellungen konnten nicht abgerufen werden.";
var fetchQuestionSummaryError = "Quiz-Zusammenfassung konnte nicht abgerufen werden.";
var De = {
	instructions: instructions,
	auto: auto,
	quality: quality,
	speed: speed,
	subtitles: subtitles,
	settings: settings,
	on: on,
	off: off,
	subtitlesOff: subtitlesOff,
	previous: previous,
	noAnswerSelected: noAnswerSelected,
	"Include your own strings in JSON files.": "Include your own strings in JSON files.",
	Automatic: Automatic,
	Instructions: Instructions,
	question: question,
	back: back,
	next: next,
	skip: skip,
	submit: submit,
	chooseAnswer: chooseAnswer,
	typeAnswer: typeAnswer,
	somethingError: somethingError,
	qaSummary: qaSummary,
	passed: passed,
	failed: failed,
	result: result,
	score: score,
	attempts: attempts,
	expiresIn: expiresIn,
	clickHereTo: clickHereTo,
	tryAgain: tryAgain,
	rightSelection: rightSelection,
	wrongSelection: wrongSelection,
	ungraded: ungraded,
	correctAnswers: correctAnswers,
	of: of,
	createQuestionAttemptError: createQuestionAttemptError,
	fetchQuestionSetError: fetchQuestionSetError,
	fetchQuestionAttemptError: fetchQuestionAttemptError,
	fetchQuizSettingsError: fetchQuizSettingsError,
	fetchQuestionSummaryError: fetchQuestionSummaryError
};

// /* global Headers, fetch, navigator*/
const Plugin = videojs.getPlugin('plugin');

// Default options for the plugin.
const defaults = {
  directory: null,
  width: 0,
  height: 0,
  spriteWidth: 0,
  spriteHeight: 0,
  interval: 1,
  responsive: 600,
  downlink: 2,
  styles: {
    primaryColor: '#d00',
    secondaryColor: '#0d0'
  }
};

/**
 * An advanced Video.js plugin. For more information on the API
 *
 * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
 */
class SdPlugin extends Plugin {
  /**
   * Create a SdPlugin plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */
  constructor(player, options) {
    // the parent class will add player under this.player
    /**
     * enable Muted Autoplay
     */
    if (options && options.playerSettings && options.playerSettings.enableMutedAutoplay) {
      player.autoplay(true);
      player.muted(true);
    }

    /**
     * enable Loop
     */
    if (options && options.playerSettings && options.playerSettings.loopEnabled) {
      player.loop(true);
    }
    super(player);
    videojs.options.vhs.overrideNative = true;
    this.options = videojs.obj.merge(defaults, options);
    this.startedPlay = false;

    // Set languages on the plugin object
    player.getLanguage = (key = undefined) => {
      const pluginLanguages = {
        de: De,
        en: En
      };
      if (options && options.playerSettings) {
        // Get language
        let lang = options.playerSettings.language ? options.playerSettings.language : window.navigator.language;
        // If key is not passed return all languages

        if (!key) {
          return pluginLanguages;
        }
        // If language comes from navigator it does include -Gb for example
        // Key has to be only short code
        if (lang.includes('-')) {
          const [languageCode] = lang.split('-');
          lang = languageCode;
        }
        if (pluginLanguages && pluginLanguages[lang] && pluginLanguages[lang][key]) {
          // Found language string
          return pluginLanguages[lang][key];
        }
        // If key is not found return error
        throw new Error('Language key is not found.');
      }
    };
    /**
     * Add Options Button
     */
    this.player.controlBar.addChild('OptionsButton', {
      options: this.options,
      controlText_: 'Options'
    });
    //

    //  Bind Events
    this.player.on(CustomPlayerEvents.UPDATEOPTIONSMENU, this.onUpdateOptionsMenu.bind(this));

    /**
     * QualitySelector
     */

    const disposeHandler = function () {
      // qualityList.dispose();

      if (this.player.textTracks_) {
        const textTracks = this.player.textTracks_.tracks_;
        if (textTracks.length) {
          textTracks.forEach(t => {
            this.player.removeRemoteTextTrack(t);
          });
        }
      }
      // this.player.qualityLevels = originalPluginFn;
      this.player.off = (PlayerEvents.DISPOSE, disposeHandler);
    };
    this.player.on(PlayerEvents.DISPOSE, disposeHandler);
    // this.player.qualityLevels = () => qualityList;

    // On player ready

    this.player.ready(async () => {
      this.player.addClass('vjs-sd-plugin');

      /**
       * If HLS Streaming init quality Menu
       */

      // if (this.player.qualityLevels && this.player.tech({IWillNotUseThisInPlugins: true}).vhs) {
      // if (this.player.qualityLevels) {
      // this.createQualityMenu();
      // this.bindPlayerEvents();
      // }

      /**
       * Add Seekbar Buttons
       */
      this.player.controlBar.seekForward = player.controlBar.addChild('seekButton', {
        direction: 'forward',
        seconds: 10
      }, 1);
      this.player.controlBar.seekBackward = player.controlBar.addChild('seekButton', {
        direction: 'backward',
        seconds: 10
      }, 2);
      this.root = this.player.el_;
      this.isShadowRoot = false;
      this.root.querySelector('.skip-backward .vjs-icon-placeholder').innerHTML = '<span>10</span><svg width="40" height="40" viewBox="0 0 36 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.63116 35.3799C1.79676 31.5455 -0.0359377 26.2529 0.625634 20.8626C0.708677 20.1787 1.33301 19.6908 2.01778 19.7743C2.70929 19.8544 3.19345 20.4802 3.10709 21.1676C2.53909 25.7882 4.10176 30.3243 7.3887 33.6113C13.2389 39.4615 22.7556 39.4576 28.6069 33.6063C34.4582 27.755 34.4604 18.2367 28.6119 12.3881C24.8056 8.58188 19.3191 7.15205 14.1441 8.53189L16.7653 11.1532C17.2515 11.6393 17.2513 12.435 16.7649 12.9213C16.2785 13.4077 15.4829 13.4079 14.9967 12.9218L10.047 7.972C9.55864 7.48366 9.56103 6.69019 10.0474 6.20382L14.9995 1.25175C15.488 0.763181 16.2793 0.762995 16.7676 1.25134C17.256 1.73969 17.2558 2.53095 16.7672 3.01952L13.7186 6.06814C19.6916 4.55881 25.9881 6.23932 30.3799 10.6311C37.2024 17.4536 37.2003 28.5484 30.3746 35.3741C23.549 42.1997 12.4536 42.2023 5.63116 35.3799Z" fill="white" fill-opacity="0.75"/></svg>';
      this.root.querySelector('.skip-forward .vjs-icon-placeholder').innerHTML = '<span>10</span><svg width="40" height="40" viewBox="0 0 36 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.3688 35.3799C34.2032 31.5455 36.0359 26.2529 35.3744 20.8626C35.2913 20.1787 34.667 19.6908 33.9822 19.7743C33.2907 19.8544 32.8065 20.4802 32.8929 21.1676C33.4609 25.7882 31.8982 30.3243 28.6113 33.6113C22.7611 39.4615 13.2444 39.4576 7.39312 33.6063C1.54183 27.755 1.5396 18.2367 7.38815 12.3881C11.1944 8.58188 16.6809 7.15205 21.8559 8.53189L19.2347 11.1532C18.7485 11.6393 18.7487 12.435 19.2351 12.9213C19.7215 13.4077 20.5171 13.4079 21.0033 12.9218L25.953 7.972C26.4414 7.48366 26.439 6.69019 25.9526 6.20382L21.0005 1.25175C20.512 0.763181 19.7207 0.762995 19.2324 1.25134C18.744 1.73969 18.7442 2.53095 19.2328 3.01952L22.2814 6.06814C16.3084 4.55881 10.0119 6.23932 5.62011 10.6311C-1.20237 17.4536 -1.20032 28.5484 5.62536 35.3741C12.451 42.1997 23.5464 42.2023 30.3688 35.3799Z" fill="white" fill-opacity="0.75"/></svg>';
      this.root.querySelector('.vjs-play-control .vjs-icon-placeholder').innerHTML = '<svg class="play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM176 168V344C176 352.7 180.7 360.7 188.3 364.9C195.8 369.2 205.1 369 212.5 364.5L356.5 276.5C363.6 272.1 368 264.4 368 256C368 247.6 363.6 239.9 356.5 235.5L212.5 147.5C205.1 142.1 195.8 142.8 188.3 147.1C180.7 151.3 176 159.3 176 168V168z"/></svg><svg class="pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM224 191.1v128C224 337.7 209.7 352 192 352S160 337.7 160 320V191.1C160 174.3 174.3 160 191.1 160S224 174.3 224 191.1zM352 191.1v128C352 337.7 337.7 352 320 352S288 337.7 288 320V191.1C288 174.3 302.3 160 319.1 160S352 174.3 352 191.1z"/></svg>';

      /**
       * Thumbnails
       */
      if (this.options.directory !== undefined && this.options.directory !== null) {
        const t = new SdThumbnails(this.player, this, this.options);
        t.init();
      }
      if (options && options.playerSettings.tracks && options.playerSettings.tracks.textTracks) {
        // ** Fetch tracks ** //
        await this.invokeRemoteTracks();
        this.checkTracks();
      }

      /**
       * If StoryMode enabled
       */
      if (options && options.story) {
        const story = new SdStory(this.player, this, this.options);
        story.doNothing();
      }

      /**
       * Player Clean Mode
       */
      if (options && options.playerSettings && options.playerSettings.cleanPlayer) {
        this.player.addClass('controls-hidden');
        this.player.addClass('vjs-show-big-play-button-on-pause');
      }

      /**
       * Player disable Controls
       */
      if (options && options.playerSettings && options.playerSettings.enableControls === false) {
        this.player.addClass('controls-hidden');
        const playerEl = this.root.querySelector('.vjs-tech');
        playerEl.style.pointerEvents = 'none';
      }

      /**
       * Play Button text
       */
      if (options && options.playerSettings && options.playerSettings.playButtonText) {
        const bigPlayButton = this.root.querySelector('.vjs-big-play-button .vjs-control-text');
        this.player.addClass('play-button-custom-text');
        bigPlayButton.innerHTML = options.playerSettings.playButtonText;
      }

      /**
       * Play Button position
       */
      if (options && options.playerSettings && options.playerSettings.playButtonPosition) {
        const bigPlayButton = this.root.querySelector('.vjs-big-play-button');
        if (options.playerSettings.playButtonPosition.y) {
          bigPlayButton.style.setProperty('top', options.playerSettings.playButtonPosition.y, 'important');
        }
        if (options.playerSettings.playButtonPosition.x) {
          bigPlayButton.style.setProperty('left', options.playerSettings.playButtonPosition.x, 'important');
        }
      }

      /**
       * Custom Playbutton image
       */
      if (options && options.playerSettings && options.playerSettings.playButtonImageUrl) {
        const bigPlayButton = this.root.querySelector('.vjs-big-play-button');
        this.player.addClass('play-button-custom-image');
        const imgEl = new window.Image();
        imgEl.style.width = 'auto';
        if (options.playerSettings.playButtonPositon && options.playerSettings.playButtonPositon.y && options.playerSettings.playButtonPositon.x) {
          imgEl.style.transform = `translate(${options.playerSettings.playButtonPositon.y}%,${options.playerSettings.playButtonPositon.x}%)`;
        }
        imgEl.src = options.playerSettings.playButtonImageUrl;
        bigPlayButton.append(imgEl);
      }

      /**
       * Show Instructions
       */
      if (options && options.playerSettings && options.playerSettings.activateInstructionsForPlaying) {
        const styleEl = document.createElement('style');
        styleEl.textContent = `
          .vjs-big-play-button:after {
            content: "${this.player.getLanguage('instructions')}";
            position: absolute;
            width: auto;
            font-size: 14px;
            line-height: 1.2;
            transform: ${this.player.hasClass('play-button-custom-image') ? 'translate(0, 0%)' : 'translate(0%, 120%)'};
          }
        `;
        this.root.append(styleEl);
      }

      /**
       * OverlayPlayerLogoUrl image
       */
      if (options && options.playerSettings && options.playerSettings.showOverlayPlayerLogo && options.playerSettings.overlayPlayerLogoUrl) {
        const imgEl = new window.Image();
        imgEl.style.position = 'absolute';
        imgEl.style.top = '1rem';
        imgEl.style.right = '1rem';
        imgEl.style.maxWidth = '40px';
        imgEl.src = options.playerSettings.overlayPlayerLogoUrl;
        this.root.append(imgEl);
      }

      /**
       * showToolbarPlayerLogo image
       */
      if (options && options.playerSettings && options.playerSettings.showToolbarPlayerLogo && options.playerSettings.toolbarPlayerLogoUrl) {
        const imgEl = new window.Image();
        imgEl.style.order = 10;
        imgEl.style.maxHeight = '40px';
        imgEl.style.maxWidth = '80px';
        imgEl.src = options.playerSettings.toolbarPlayerLogoUrl;
        this.root.querySelector('.vjs-fullscreen-control').parentElement.append(imgEl);
      }

      /**
       * Disable Picture in Picture
       */
      if (options && options.playerSettings && options.playerSettings.enablePopout === false) {
        this.player.controlBar.removeChild(this.player.controlBar.getChild('PictureInPictureToggle'));
      }

      /**
       * Styling
       */
      if (options && options.playerSettings) {
        const style = document.createElement('style');
        style.textContent = `
        :root {
          --sd--primary: ${options.playerSettings.timelineColor}!important;
          --sd--secondary: #fff;
        }
        .vjs-play-progress {
          background: ${options.playerSettings.timelineColor}!important;
        }
        .vjs-big-play-button {
          background-color: ${options.playerSettings.playButtonColor}!important
        }
      `;
        this.root.append(style);
      }
      if (options && options.recommendation && options.recommendation.length > 0) {
        const RecommendationList = videojs.getComponent('SdRecommendation');
        const recommendEl = new RecommendationList(this.player);
        options.recommendation.forEach(recommendation => {
          // best if it includes the child component
          recommendEl.el().appendChild(document.createTextNode(recommendation.name));
        });
        this.player.addChild(recommendEl);
      }
      if (options && options.showChapter) {
        const that = this;
        this.player.on(CustomPlayerEvents.LOADCHAPTERS, function () {
          const total = that.player.duration();
          const progress = document.querySelector('.vjs-progress-holder');
          const oldChapters = document.getElementsByClassName('vjs-marker');
          if (oldChapters && oldChapters.length > 0) {
            Array.from(oldChapters).forEach(old => {
              if (old) {
                progress.removeChild(old);
              }
            });
          }
          that.player.state.chapters.forEach(function (marker) {
            const left = marker.start / 1000 / total * 100 + '%';
            const time = (marker.end - marker.start) / 1000;
            const el = document.createElement('div');
            el.classList.add('vjs-marker');
            el.style.left = left;
            el.style.width = `${(marker.end - marker.start) / 1000 / total * 100}%`;
            el.dataset.time = time;
            el.id = marker.id + '_marker';
            el.innerHTML = '<div class="vjs-marker-bg" id="' + marker.id + '_marker-bg"></div><span class="chapter-title" id="chapter-' + marker.id + '">' + marker.label + '</span>';
            progress.appendChild(el);
            const title = document.getElementById('chapter-' + marker.id);
            title.style.transform = '';
          });
          that.player.on(this.player_.controlBar.el_, DomEvents.MOUSEMOVE, e => {
            if (!e.target) {
              return;
            }
            const title = document.getElementById('chapter-' + e.target.id.split('_')[0]);
            if (title) {
              const titleParent = title.parentElement;
              const parentRect = titleParent.getBoundingClientRect();
              const controlBar = this.player_.controlBar.el_;
              const controlBarRect = controlBar && this.player_.controlBar.el_.getBoundingClientRect();
              const titleRect = title.getBoundingClientRect();
              const position = e.clientX - titleRect.width / 2 - parentRect.left;
              title.style.maxWidth = controlBarRect.width * 0.6 + 'px';
              title.style.width = 'max-content';
              title.style.left = 0;
              title.style.transform = `translateX(${position}px)`;
              if (e.clientX + titleRect.width / 2 > controlBarRect.right - 10) {
                title.style.transform = `translateX(${controlBarRect.right - parentRect.left - titleRect.width - 10}px)`;
              } else if (e.clientX - titleRect.width / 2 < controlBarRect.left + 10) {
                title.style.transform = `translateX(${-(parentRect.left - title.parentElement.parentElement.getBoundingClientRect().left) + 10}px)`;
              }
              title.style.opacity = 1;
            }
          });
        });
      }
      const that = this;
      this.player.on(CustomPlayerEvents.LOADFOCUSEXTENSION, function () {
        const focusedExtension = that.player.state.overlay;
        if (focusedExtension) {
          if (focusedExtension.focusType === 'overlay') {
            if (focusedExtension.start) {
              that.player.currentTime(focusedExtension.start / 1000);
              that.player.pause();
            }
            this.currentOverlay = new SdOverlay(that.player, that.options, focusedExtension);
          }
          if (focusedExtension.focusType === 'interaction') {
            if (focusedExtension.start) {
              that.player.currentTime(focusedExtension.start / 1000);
              that.player.pause();
            }
            this.currentInteraction = new SdInteraction(that.player, that.options, focusedExtension);
          }
        }
      });
      this.player.on(CustomPlayerEvents.REMOVEFOCUSEXTENSION, function () {
        const focusedExtension = that.player.state.oldOverlay;
        if (focusedExtension) {
          if (focusedExtension.focusType === 'overlay') {
            const exists = document.getElementById(focusedExtension.id);
            if (exists) {
              exists.remove();
            }
            const stylesheetExists = document.getElementById('stylesheet-' + focusedExtension.id);
            if (stylesheetExists) {
              stylesheetExists.remove();
            }
          }
          if (focusedExtension.focusType === 'interaction') {
            if (document.getElementById(focusedExtension.id)) {
              document.getElementById(focusedExtension.id).remove();
            }
            if (document.querySelector('.vjs-interaction') !== null) {
              document.querySelector('.vjs-interaction').remove();
            }
          }
        }
      });
      this.player.on(PlayerEvents.PLAY, () => {
        that.startedPlay = true;
        if (options && options.title) {
          that.player.titleBar.setState({
            title: options.title
          });
        }
        const bigPlayButton = this.root.querySelector('.vjs-big-play-button');
        if (bigPlayButton) {
          bigPlayButton.remove();
        }
      });
      this.player.on(DomEvents.MOUSELEAVE, () => {
        if (that.startedPlay) {
          if (that.player.controls()) {
            that.player.controls(false);
          }
          if (options && options.title) {
            that.player.titleBar.setState({
              title: null
            });
          }
        }
      });
      this.player.on(DomEvents.MOUSEENTER, () => {
        if (that.startedPlay) {
          if (!that.player.state.disableControls) {
            that.player.controls(true);
          }
          if (options && options.title) {
            that.player.titleBar.setState({
              title: options.title
            });
          }
        }
      });
      const textTracksList = player.textTracks();
      textTracksList.on(DomEvents.CHANGE, () => {
        const tracks = this.options.playerSettings.tracks.textTracks;
        if (!this.options.playerSettings.controls) {
          for (let i = 0; i < tracks.length; i++) {
            if (tracks[i].mode !== player.textTracks()[i].mode && player.textTracks()[i].kind !== 'metadata') {
              player.textTracks()[i].mode = tracks[i].mode;
            }
          }
        }
      });
    });
  }

  //  ** END OF CONSTRUCTOR ** //

  /* ************ //
   ** Subcaps button **
   ** ************ */

  checkTracks() {
    if (this.options && this.options.playerSettings && this.options.playerSettings.tracks) {
      const textTracksList = this.options.playerSettings.tracks.textTracks;
      const playerTextTracks = this.player.textTracks();
      const subsCapsButton = this.player.controlBar.getChild('SubsCapsButton');
      if (textTracksList.length < 2) {
        // prevent the vjs-hover class to apply to show vjs-menu
        subsCapsButton.getChild('SubsCapsButton').disable();
        subsCapsButton.el_.addEventListener('click', function () {
          const isTextTrackActive = this.classList.contains('active');
          if (isTextTrackActive) {
            playerTextTracks.tracks_.forEach(track => {
              track.mode = 'hidden';
            });
          } else {
            const track = playerTextTracks.tracks_.find(textTrack => textTrack.label === textTracksList[0].displayName);
            track.mode = 'showing';
          }
        });
      }
    }
  }

  /* ************ //
   ** Options Menu **
   ** ************ */
  async invokeRemoteTracks() {
    if (this.options && this.options.playerSettings && this.options.playerSettings.tracks) {
      const textTracksList = this.options.playerSettings.tracks.textTracks;

      // remove text tracks to prevent caching on all videos
      for (let i = 0; i < textTracksList.length; i++) {
        const track = textTracksList[i];
        const fetchData = await fetchWithAuthentication(track.url, this.options.token);
        const blob = await fetchData.blob();
        const objectUrl = URL.createObjectURL(blob);
        const captionOption = {
          kind: 'subtitles',
          language: track.languageCode,
          label: track.displayName,
          src: objectUrl,
          mode: track.mode ? track.mode : 'disabled',
          default: track.default ? track.default : false
        };
        // Set new Tracks to player

        this.addTracks(captionOption);
      }
    }
  }
  onUpdateOptionsMenu() {
    this.player.controlBar.removeChild('OptionsButton');
    this.player.controlBar.addChild('OptionsButton', {
      options: this.options,
      controlText_: 'Options'
    });
    return this.options;
  }
  addTracks(track) {
    if (!track) {
      return;
    }
    if (this.player) {
      const trackEl = this.player.addRemoteTextTrack(track);
      // second argument sets the track if it should be enabled OR disabled by default

      trackEl.addEventListener('load', function (e) {
        e.target.default = true;
      });
    }
  }
}

// Define default values for the plugin's `state` object here.
SdPlugin.defaultState = {};

// Include the version number.
SdPlugin.VERSION = version;

// Register the plugin with video.js.
videojs.registerPlugin('sdPlugin', SdPlugin);
// Register sdrecommend
videojs.registerComponent('SdRecommendation', SdRecommendList);
// Register SeekButton Component
videojs.registerComponent('SeekButton', SdSeekButton);

// Register Quality Menu
videojs.registerComponent('SdQualityMenu', SdQualityMenu);

// Register Options Button
videojs.registerComponent('OptionsButton', SdOptionsButton);

export { SdPlugin as default };
